var _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8, _path2, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _path3, _g30, _g31, _path4, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _path5, _g41, _g42, _path6, _g43, _path7, _g44, _g45, _g46, _g47, _g48, _g49, _path8, _g50, _path9, _g51, _g52, _path10, _path11, _g53, _g54, _path12, _g55, _path13, _g56, _g57, _path14, _path15, _g58, _g59, _path16, _path17, _g60, _path18, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProdRoom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 715,
  height: 535,
  viewBox: "0 0 715 535",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__image_1"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_3"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48932 142.076L283.096 1.77161L712.509 216.48V392.924L431.903 533.229L2.48932 318.52V142.076Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.69745 140.492L282.304 0.187339C282.804 -0.0624462 283.388 -0.0624462 283.888 0.187339L713.302 214.896C713.902 215.196 714.281 215.809 714.281 216.48V392.924C714.281 393.595 713.902 394.209 713.302 394.508L432.694 534.813C432.195 535.062 431.61 535.062 431.111 534.813L1.69745 320.104C1.09692 319.805 0.719604 319.191 0.719604 318.52V142.076C0.719604 141.405 1.09692 140.792 1.69745 140.492ZM2.48932 142.076V318.52L431.903 533.229L712.509 392.924V216.48L283.096 1.77161L2.48932 142.076Z",
  fill: "#141941"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M704.006 220.732V386.547L274.593 171.838V6.02332L704.006 220.732Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M712.509 216.48V369.54L704.006 373.792V220.732L712.509 216.48Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48938 295.136L431.903 509.845L704.006 373.792L274.593 159.083L2.48938 295.136Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M295.851 288.759L304.354 293.01L576.458 156.957L567.954 152.706L295.851 288.759Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_9"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_7",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.354 293.01V446.07L576.457 310.017V156.957L304.354 293.01Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_10"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_8",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.18 208.509V346.156L559.451 318.52V180.873L504.18 208.509Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask0_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 504,
  y: 180,
  width: 56,
  height: 167
}, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip1"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_9",
  d: "M504.18 208.509V346.156L559.451 318.52V180.873L504.18 208.509Z",
  fill: "white"
})))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask0_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_11"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_12"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_10",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M410.645 307.891L508.432 356.785L589.212 316.394L491.425 267.5L410.645 307.891Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.53923,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_13"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_11",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M550.948 169.712V314.269L559.451 318.52V173.964L550.948 169.712Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.53923,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_14"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_12",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M555.199 180.341V316.395L499.103 343.873V207.82L555.199 180.341Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_13",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.18 208.509V346.156L559.451 318.52V180.873L504.18 208.509Z",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_15"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_16"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_14",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M549.459 253.517C549.78 253.353 550.153 253.371 550.459 253.555C550.766 253.739 550.948 254.071 550.948 254.427C550.948 257.819 550.948 265.435 550.948 268.323C550.948 269.023 550.554 269.665 549.934 269.983C549.678 270.113 549.393 270.259 549.116 270.401C548.802 270.561 548.422 270.547 548.116 270.363C547.816 270.175 547.634 269.844 547.634 269.487C547.634 266.095 547.634 258.48 547.634 255.591C547.634 254.891 548.021 254.253 548.649 253.932C548.904 253.801 549.189 253.656 549.459 253.517Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.04556,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_17"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_15",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M552.842 260.114C552.842 259.762 552.657 259.43 552.353 259.241C552.05 259.059 551.671 259.043 551.354 259.205C549.293 260.259 545.623 262.136 543.849 263.043C543.226 263.362 542.834 264.005 542.834 264.701C542.834 264.896 542.834 265.098 542.834 265.293C542.834 265.653 543.019 265.985 543.323 266.167C543.626 266.356 544.005 266.365 544.322 266.203C546.383 265.149 550.053 263.271 551.827 262.364C552.45 262.046 552.842 261.41 552.842 260.706C552.842 260.519 552.842 260.317 552.842 260.114Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.896414,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_18"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_16",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9926 146.328V299.388L283.096 163.335V10.2749L10.9926 146.328Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_19"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_17",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.903 533.229V509.845L712.509 369.54V392.924L431.903 533.229Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_20"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_18",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M295.851 288.759V441.818L304.354 446.07V293.01L295.851 288.759Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_21"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_19",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48938 142.076V295.136L10.9926 299.388V146.328L2.48938 142.076Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_22"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_20",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48938 318.52V295.136L431.903 509.845V533.229L2.48938 318.52Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_23"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_21",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M712.509 216.48V369.54L704.006 373.792V220.732L712.509 216.48Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_24"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_22",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.903 533.229V509.845L712.509 369.54V392.924L431.903 533.229Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_25"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_23",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48938 142.076V295.136L10.9926 299.388V146.328L2.48938 142.076Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_26"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_24",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48938 318.52V295.136L431.903 509.845V533.229L2.48938 318.52Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Wyposa\\xC5\\xBCenie"
}, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Obraz 5"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_25",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M400.246 95.0334V169.296L357.359 147.852V73.589L400.246 95.0334Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897247,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_26",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.875 96.4858V165.476L359.726 146.4V77.41L397.875 96.4858Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899545,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Obraz 4"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_27",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M450.999 120.361V194.624L408.113 173.18V98.917L450.999 120.361Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897247,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_28",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.629 121.814V190.804L410.48 171.728V102.738L448.629 121.814Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899545,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Obraz 3"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_29",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.4634 157.061V234.522L82.1963 212.154V134.694L37.4634 157.061Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899684,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_30",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.9347 158.575V230.536L79.7258 210.639V138.678L39.9347 158.575Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.896881,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Obraz 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_31",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.6807 132.581V173.495L128.329 153.171V112.257L87.6807 132.581Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897247,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_32",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.05 134.033V169.675L125.96 151.72V116.078L90.05 134.033Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899545,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Obraz 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_33",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.5262 182.128V209.488L105.567 200.967V173.607L88.5262 182.128Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897247,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_34",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.8945 183.579V205.667L103.198 199.515V177.427L90.8945 183.579Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899545,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Rega\\xC5\\x82"
}, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_27"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_28"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_35",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.858 173.964V199.474L317.242 197.282V171.772L312.858 173.964Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_29"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_36",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.606 171.838V197.348L312.858 199.474V173.964L308.606 171.838Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_30"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_31"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_37",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M329.864 165.461V190.971L334.249 188.778V163.268L329.864 165.461Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_32"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_38",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.613 163.335V188.845L329.864 190.971V165.461L325.613 163.335Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_33"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_34"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_39",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.223 150.646V176.156L270.607 173.964V148.454L266.223 150.646Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_35"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_40",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M261.971 148.52V174.03L266.223 176.156V150.646L261.971 148.52Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_36"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_41",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M261.972 54.9838L312.992 80.4937L334.25 69.8646L283.23 44.3546L261.972 54.9838Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_37"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_42",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.99 80.4935V191.037L334.248 180.408V69.8644L312.99 80.4935Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_38"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_43",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M261.972 54.9838V165.527L312.991 191.037V80.4937L261.972 54.9838Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_39"
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_44",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 58.3362V163.951L310.685 187.261V81.6464L264.066 58.3362Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_2"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask1_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 264,
  y: 58,
  width: 47,
  height: 130
}, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip3"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_45",
  d: "M264.066 58.3362V163.951L310.685 187.261V81.6464L264.066 58.3362Z",
  fill: "white"
})))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask1_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_40"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_41"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_46",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 77.6149L315.085 103.125L336.343 92.4957L285.324 66.9857L264.066 77.6149Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_42"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_47",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 99.199L315.085 124.709L336.343 114.08L285.324 88.5698L264.066 99.199Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_43"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_48",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 120.783L315.085 146.293L336.343 135.664L285.324 110.154L264.066 120.783Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_44"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_49",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 142.367L315.085 167.877L336.343 157.248L285.324 131.738L264.066 142.367Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_45"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_50",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 163.951L315.085 189.461L336.343 178.832L285.324 153.322L264.066 163.951Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_51",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 58.3362V163.951L310.685 187.261V81.6464L264.066 58.3362Z",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_46"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 77.6146V79.9201L310.685 103.23V100.925L264.066 77.6146Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_47"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_53",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 99.1987V101.504L310.685 124.814V122.509L264.066 99.1987Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_48"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_54",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 120.782V123.088L310.685 146.398V144.093L264.066 120.782Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_49"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_55",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.066 142.366V144.672L310.685 167.982V165.677L264.066 142.366Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__szafka TV"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_50"
}, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_51"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_52"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_56",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.44 208.32V233.83L207.824 231.638V206.128L203.44 208.32Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_53"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_57",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.188 206.195V231.705L203.44 233.831V208.321L199.188 206.195Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_54"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_55"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_58",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.792 248.645V274.155L127.176 271.963V246.453L122.792 248.645Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_56"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_59",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.54 246.519V272.029L122.792 274.155V248.645L118.54 246.519Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_57"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_58"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_60",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.2819 235.89V261.4L101.666 259.208V233.698L97.2819 235.89Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_59"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_61",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.0303 233.764V259.274L97.2819 261.4V235.89L93.0303 233.764Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_60"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_62",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.0313 225.261L122.793 240.142L207.825 197.625L178.064 182.744L93.0313 225.261Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_61"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_63",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.791 240.141V265.651L207.823 223.135V197.625L122.791 240.141Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_62"
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_64",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.214 241.586V261.781L205.628 221.574V201.379L125.214 241.586Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask2_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 125,
  y: 201,
  width: 81,
  height: 61
}, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip2"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_65",
  d: "M125.214 241.586V261.781L205.628 221.574V201.379L125.214 241.586Z",
  fill: "white"
})))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask2_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_63"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_64"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_66",
  d: "M180.228 207.438L178.125 208.495V235.333L180.228 234.276V207.438Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.09897,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_65"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_67",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.358 194.94V220.45L178.119 235.331V209.821L148.358 194.94Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_66"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_68",
  d: "M152.723 221.196L150.619 222.248V249.08L152.723 248.029V221.196Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.09826,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_67"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_69",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.858 208.69V234.2L150.62 249.08V223.571L120.858 208.69Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_68"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_70",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.869 181.184V206.694L205.631 221.575V196.065L175.869 181.184Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_71",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.214 241.586V261.781L205.628 221.574V201.379L125.214 241.586Z",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_69"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_72",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.0312 225.261V250.771L122.793 265.651V240.142L93.0312 225.261Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_73",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.096 1.77148L712.509 216.48L704.006 220.732L283.096 10.2753L10.9926 146.328L2.48938 142.076L283.096 1.77148Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.866547,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Kwiat"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_70"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_71"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_72"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_74",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M161.895 180.501C161.895 180.501 157.126 165.808 149.901 158.075C143.909 151.661 149.71 146.401 154.519 150.879C166.24 162.088 161.895 180.501 161.895 180.501Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.869144,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_75",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M151.382 200.463H151.381V185.31H172.769V200.463C172.786 201.793 171.7 203.119 169.524 204.107C165.286 206.03 158.51 205.95 154.399 203.928C152.422 202.954 151.419 201.708 151.382 200.463Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.868678,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_73"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_76",
  d: "M169.522 188.974C173.762 187.049 173.864 183.848 169.751 181.825C165.638 179.801 158.866 179.721 154.626 181.646C150.386 183.57 150.284 186.771 154.397 188.795C158.51 190.819 165.282 190.899 169.522 188.974Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.700631,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_74"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_77",
  d: "M168.21 187.956C171.702 186.566 171.786 184.254 168.398 182.792C165.011 181.33 159.434 181.272 155.942 182.663C152.45 184.053 152.365 186.365 155.753 187.827C159.141 189.289 164.718 189.346 168.21 187.956Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.684508,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_75"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_78",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M161.825 186.187C161.825 186.187 158.782 175.992 147.794 169.041C142.428 165.647 143.034 162.847 143.878 160.947C144.541 159.453 148.547 158.126 152.836 161.613C166.086 172.384 161.825 186.187 161.825 186.187Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.896481,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_76"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_79",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M161.712 186.571C161.712 186.571 153.209 174.996 146.956 175.252C136.17 175.693 148.092 168.392 153.603 172.801C159.729 177.701 161.712 186.571 161.712 186.571Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.872828,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_77"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_80",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.739 172.903C153.739 172.903 148.725 168.89 144.191 171.51C141.608 173.001 142.036 178.201 145.388 177.492C148.74 176.782 151.336 171.543 153.739 172.903Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.855507,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_78"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_81",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.068 186.818C162.068 186.818 165.785 178.931 175.619 174.008C185.129 169.247 178.735 160.141 170.841 168.465C164.599 175.047 162.068 186.818 162.068 186.818Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.933241,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_79"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_82",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.416 180.831C162.416 180.831 162.884 167.734 172.129 156.38C180.984 145.508 170.24 140.713 163.901 151.161C155.384 165.197 162.416 180.831 162.416 180.831Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.899076,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Fotel"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_80"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_83",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.024 337.914C132.962 338.26 133.061 338.616 133.294 338.881C133.526 339.146 133.866 339.291 134.218 339.274C134.298 339.271 134.376 339.268 134.45 339.264C134.788 339.249 135.079 339.021 135.177 338.697C136.456 334.433 144.857 306.429 144.857 306.429L138.705 306.019C138.705 306.019 134.159 331.544 133.024 337.914Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_81"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_84",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.683 300.688C129.683 300.688 123.125 318.721 121.737 322.539C121.583 322.963 121.182 323.249 120.731 323.256C120.393 323.262 120.069 323.111 119.854 322.848C119.64 322.584 119.558 322.237 119.632 321.906C120.89 316.29 125.582 295.356 125.582 295.356L129.683 300.688Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_82"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_85",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.873 303.783C169.873 303.783 181.756 326.445 183.685 330.124C183.846 330.432 184.166 330.626 184.514 330.626C184.64 330.626 184.777 330.626 184.919 330.626C185.228 330.626 185.516 330.474 185.69 330.221C185.866 329.967 185.904 329.644 185.795 329.356C183.701 323.845 175.503 302.269 175.503 302.269L169.873 303.783Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_83"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_86",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.492 303.148C162.492 303.148 165.306 313.783 166.02 316.478C166.114 316.835 166.447 317.077 166.817 317.058C166.962 317.049 167.118 317.041 167.268 317.033C167.481 317.022 167.68 316.923 167.819 316.761C167.957 316.598 168.024 316.386 168.003 316.173C167.688 313.094 166.593 302.328 166.593 302.328L162.492 303.148Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_84"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_87",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M136.421 265.862C138.427 267.497 139.824 269.758 140.388 272.283C141.651 277.9 143.959 288.215 145.334 294.366C145.616 295.623 146.428 296.695 147.561 297.306C148.695 297.917 150.037 298.006 151.241 297.55C160.983 293.859 182.193 285.824 182.193 285.824C182.193 285.824 183.249 286.804 184.287 287.767C185.55 288.94 186.237 290.606 186.168 292.329C186.118 293.571 186.059 295.043 186.009 296.3C185.937 298.067 184.914 299.657 183.335 300.453C176.41 303.848 156.683 312.441 139.513 309.494C122.739 306.612 111.699 271.878 110.872 254.374C110.781 252.497 111.85 250.757 113.564 249.988C115.279 249.219 117.289 249.578 118.631 250.893C124.516 256.163 132.209 262.458 136.421 265.862Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_85"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_88",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.752 290.478C183.45 290.307 183.999 289.767 184.179 289.07C184.361 288.374 184.144 287.635 183.618 287.146C179.599 283.416 172.08 276.438 168.593 273.201C167.428 272.12 165.8 271.695 164.256 272.067C157.915 273.596 141.57 277.536 141.57 277.536C141.57 277.536 144.008 288.437 145.438 294.831C145.705 296.025 146.442 297.061 147.481 297.706C148.52 298.351 149.776 298.55 150.963 298.26C158.972 296.299 175.511 292.25 182.752 290.478Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898792,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Re\\xC5\\xBCyser"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_86"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_89",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.834 340.271C376.819 340.214 376.815 340.155 376.824 340.096C376.827 340.076 376.831 340.057 376.836 340.038C376.864 339.92 376.941 339.816 377.05 339.755C377.108 339.722 377.171 339.704 377.235 339.699L405.559 329.677C405.697 329.628 405.85 329.65 405.967 329.736L409.678 332.432C409.786 332.508 409.851 332.626 409.861 332.753L411.648 353.912C411.667 354.112 411.545 354.299 411.353 354.366L399.341 358.617C399.698 359.104 399.909 359.704 399.909 360.353C399.909 361.875 398.75 363.128 397.268 363.277V371.185L407.741 375.813L416.8 364.119C419.205 361.014 422.72 358.962 426.608 358.395L429.5 357.973C436.716 356.921 443.842 360.402 447.446 366.743L452.153 375.017C452.336 375.339 452.49 375.674 452.621 376.017C453.636 377.466 454.118 379.238 453.964 381.025L452.509 397.562C452.396 398.815 451.493 399.81 450.333 400.092C450.061 400.158 449.776 400.185 449.481 400.167C449.472 400.166 449.462 400.165 449.453 400.165L449.271 400.152C448.054 400.063 447.095 399.074 447.053 397.854L446.458 381.673L442.902 375.757L442.457 397.013L442.383 397.048L442.228 447.258H434.053L432.626 401.664L427.568 404.056L426.903 451.063H418.466L418.106 408.533L418.036 408.566L417.905 376.611L415.144 380.393L415.111 380.381C414.938 380.615 414.751 380.841 414.554 381.056C414.554 381.059 414.549 381.061 414.549 381.063C413.319 382.416 411.7 383.385 409.893 383.822C407.399 384.424 404.763 383.959 402.625 382.538L397.268 378.978V405.121L410.544 414.324C410.745 414.465 410.797 414.741 410.656 414.942C410.516 415.143 410.24 415.195 410.039 415.054L397.493 406.355L401.68 425.845C401.731 426.084 401.579 426.318 401.34 426.369C401.1 426.421 400.865 426.271 400.814 426.028L396.573 406.288L385.182 418.793C385.017 418.976 384.737 418.99 384.556 418.821C384.375 418.658 384.362 418.377 384.527 418.199L396.382 405.182V378.389L390.343 374.377C389.652 373.917 389.175 373.199 389.019 372.384C388.863 371.568 389.042 370.725 389.515 370.042L389.701 369.773C390.296 368.915 391.417 368.6 392.372 369.022L396.382 370.794V363.233C395.086 362.969 394.1 361.852 394.035 360.495L382.91 364.431C382.782 364.477 382.638 364.46 382.522 364.386C382.515 364.381 382.508 364.376 382.501 364.371L378.793 361.656C378.69 361.581 378.624 361.464 378.614 361.336L376.834 340.271ZM464.689 444.451L464.301 395.279L464.259 395.265L464.189 378.133L453.894 371.122C451.765 369.669 450.323 367.402 449.921 364.855C449.556 362.573 450.052 360.247 451.292 358.319C451.33 358.205 451.835 357.743 451.835 357.743L463.711 348.22C465.719 346.612 468.1 345.54 470.637 345.104L475.962 344.189C483.056 342.971 490.178 346.165 493.987 352.27L498.896 360.142C499.378 360.914 499.7 361.764 499.855 362.645C500.07 363.319 500.154 364.043 500.08 364.785L498.577 380.433C498.446 381.795 497.44 382.864 496.167 383.131C496.097 383.145 496.032 383.157 495.962 383.167C495.742 383.198 495.512 383.205 495.283 383.185L495.077 383.168C493.617 383.045 492.494 381.825 492.494 380.361V367.921L492.489 365.166L487.88 357.298C488.601 367.287 488.882 376.352 488.68 384.392L488.648 384.436L488.325 440.646H480.15L478.98 393.492L473.763 395.816L473.126 444.451H464.689ZM463.524 369.023L464.156 369.635L464.123 361.766C464.123 361.194 464.16 360.631 464.235 360.079L458.297 363.979L460.787 366.385C460.815 366.4 460.833 366.418 460.857 366.439L463.524 369.023ZM472.766 318.695C478.802 318.447 483.964 323.434 484.389 330.047C484.825 336.831 480.117 342.772 473.88 343.306C467.647 343.841 462.228 338.767 461.793 331.984C461.353 325.2 466.06 319.259 472.298 318.725C472.345 318.721 472.387 318.718 472.434 318.714C472.48 318.703 472.527 318.693 472.574 318.685C472.64 318.674 472.705 318.678 472.766 318.695ZM423.253 353.553C423.305 355.219 423.511 356.397 423.511 356.397C423.553 356.655 423.482 356.919 423.314 357.118C423.146 357.318 422.898 357.433 422.635 357.433L422.093 357.245C422.093 357.247 422.144 357.283 422.144 357.283C422.144 357.283 421.007 356.672 415.668 354.94C415.209 354.791 414.952 354.304 415.092 353.843C415.775 351.558 416.992 349.799 418.288 348.475C416.959 347.236 416.094 345.392 416.052 343.335C415.986 340.352 417.671 337.818 420.062 336.926C422.041 333.2 425.743 330.704 430.034 330.704C436.168 330.704 441.32 335.805 442.003 342.309C442.467 343.336 442.719 344.503 442.696 345.74C442.645 348.587 441.156 351.062 439.018 352.306C436.922 354.752 433.927 356.277 430.576 356.277C427.834 356.277 425.293 355.259 423.253 353.553Z",
  stroke: "#321E78",
  strokeWidth: 0.897347,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_90",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M449.453 401.051L449.21 401.035H449.205C447.539 400.915 446.229 399.558 446.168 397.887L445.579 381.933L443.721 378.843L443.342 397.032C443.342 397.152 443.314 397.266 443.267 397.369L443.112 447.258C443.112 447.75 442.719 448.143 442.228 448.143H434.053C433.571 448.143 433.178 447.764 433.164 447.286L431.784 403.042L428.447 404.621L427.787 451.077C427.783 451.559 427.385 451.947 426.903 451.947H418.466C417.979 451.947 417.586 451.554 417.582 451.067L417.221 408.918C417.175 408.811 417.151 408.693 417.147 408.57L417.03 379.31L415.86 380.916C415.808 380.985 415.747 381.047 415.682 381.098C415.532 381.288 415.373 381.473 415.209 381.652L415.205 381.66C413.857 383.143 412.083 384.204 410.099 384.683C407.367 385.343 404.478 384.833 402.135 383.276L398.153 380.63V404.658L411.049 413.599L411.255 413.772L411.414 413.978L411.531 414.207L411.601 414.455L411.62 414.708L411.592 414.961L411.517 415.214L411.386 415.448L411.208 415.653L411.002 415.813L410.773 415.929L410.53 416L410.277 416.018L410.02 415.99L409.772 415.911L409.538 415.78L398.83 408.36L402.545 425.658L402.575 425.925L402.551 426.187L402.479 426.435L402.362 426.659L402.205 426.856L402.01 427.024L401.781 427.155L401.526 427.235L401.259 427.268L400.997 427.244L400.751 427.169L400.525 427.052L400.326 426.893L400.159 426.702L400.03 426.472L399.947 426.215L396.068 408.157L385.837 419.392L385.637 419.57L385.41 419.701L385.168 419.785L384.916 419.823L384.663 419.809L384.413 419.748L384.175 419.64L383.96 419.477L383.781 419.28L383.648 419.051L383.563 418.807L383.527 418.559L383.54 418.307L383.601 418.054L383.712 417.815L383.872 417.6L395.496 404.839V378.864L389.853 375.115C388.964 374.523 388.35 373.599 388.149 372.55C387.948 371.501 388.178 370.416 388.787 369.538L388.973 369.269C389.81 368.061 391.386 367.618 392.73 368.212L395.496 369.434L395.496 363.883C394.517 363.473 393.745 362.667 393.378 361.667L383.206 365.266L382.91 365.335L382.609 365.334L382.316 365.265L382.042 365.13L381.978 365.086L378.27 362.371L378.06 362.179L377.896 361.95L377.785 361.691L377.731 361.411L375.951 340.346L375.976 340.493L375.936 340.235L375.947 339.969L375.979 339.821L376.064 339.577L376.204 339.344L376.389 339.143L376.616 338.982L376.887 338.868L376.975 338.851L405.264 328.842L405.58 328.772L405.897 328.779L406.206 328.863L406.487 329.019L410.202 331.715L410.413 331.909L410.577 332.139L410.689 332.398L410.745 332.679L412.533 353.837L412.495 354.276L412.322 354.669L412.037 354.987L411.653 355.201L400.589 359.115C400.723 359.504 400.795 359.92 400.795 360.353C400.795 362.052 399.686 363.492 398.153 363.991V370.608L407.465 374.723L416.098 363.577C418.644 360.29 422.369 358.118 426.482 357.519L429.35 357.1C427.525 356.911 425.799 356.304 424.264 355.367C424.325 355.917 424.381 356.244 424.381 356.244V356.248L424.404 356.634C424.4 356.762 424.381 356.889 424.348 357.012C424.278 357.258 424.161 357.49 423.992 357.689C423.656 358.089 423.16 358.319 422.635 358.319C422.537 358.319 422.439 358.302 422.35 358.271L422.032 358.161C421.924 358.147 421.821 358.114 421.723 358.063C421.723 358.063 420.614 357.475 415.392 355.783C414.479 355.485 413.965 354.512 414.241 353.589C414.868 351.494 415.916 349.812 417.076 348.483C415.93 347.133 415.205 345.332 415.162 343.353C415.097 340.098 416.889 337.333 419.435 336.224C421.606 332.369 425.523 329.819 430.034 329.819C436.557 329.819 442.078 335.179 442.869 342.076C443.346 343.184 443.608 344.434 443.58 345.756C443.524 348.875 441.91 351.584 439.594 352.993C437.853 354.982 435.546 356.387 432.944 356.923C439.224 357.223 445.031 360.7 448.218 366.305L452.921 374.579C453.112 374.91 453.271 375.252 453.407 375.6C454.502 377.202 455.017 379.144 454.844 381.102L453.388 397.639C453.248 399.281 452.064 400.584 450.543 400.953C450.188 401.04 449.809 401.075 449.425 401.051L449.397 401.049C449.416 401.05 449.43 401.051 449.453 401.051C449.926 401.051 450.319 400.673 450.337 400.197C450.337 400.162 450.337 400.127 450.333 400.092C451.493 399.81 452.396 398.815 452.509 397.562L453.964 381.025C454.118 379.238 453.636 377.467 452.621 376.017C452.49 375.674 452.336 375.339 452.153 375.017L447.446 366.743C443.842 360.402 436.716 356.921 429.5 357.973L426.608 358.395C422.72 358.962 419.205 361.014 416.8 364.119L407.741 375.813L397.268 371.185V363.277C398.75 363.128 399.909 361.875 399.909 360.353C399.909 359.704 399.698 359.104 399.341 358.617L411.353 354.366C411.545 354.299 411.667 354.112 411.648 353.912L409.861 332.753C409.851 332.626 409.786 332.508 409.678 332.432L405.967 329.736C405.85 329.65 405.697 329.628 405.559 329.677L377.235 339.699C377.171 339.704 377.108 339.722 377.05 339.755C376.941 339.816 376.864 339.92 376.836 340.039C376.831 340.057 376.826 340.076 376.824 340.096C376.815 340.155 376.819 340.215 376.834 340.271L378.614 361.337C378.624 361.464 378.69 361.581 378.793 361.657L382.501 364.371L382.522 364.386C382.638 364.46 382.782 364.477 382.91 364.431L394.035 360.495C394.1 361.852 395.086 362.969 396.382 363.233V370.794L392.372 369.022C391.417 368.6 390.296 368.915 389.701 369.774L389.515 370.043C389.042 370.725 388.863 371.569 389.019 372.384C389.175 373.199 389.652 373.917 390.343 374.377L396.382 378.389V405.182L384.527 418.199C384.362 418.377 384.375 418.658 384.556 418.821C384.737 418.99 385.017 418.976 385.182 418.793L396.573 406.288L400.814 426.028C400.865 426.271 401.1 426.421 401.34 426.369C401.579 426.318 401.731 426.084 401.68 425.845L397.493 406.355L410.039 415.054C410.24 415.195 410.516 415.143 410.656 414.942C410.797 414.741 410.745 414.465 410.544 414.324L397.268 405.121V378.978L402.625 382.538C404.763 383.959 407.399 384.424 409.893 383.822C411.7 383.385 413.319 382.416 414.549 381.064C414.615 381.119 414.69 381.164 414.769 381.197L414.774 381.198L414.783 381.203C414.877 381.241 414.98 381.262 415.083 381.266L414.774 381.198C414.695 381.162 414.62 381.114 414.554 381.057C414.751 380.841 414.938 380.615 415.111 380.381L415.144 380.393L417.905 376.612L418.036 408.566L418.106 408.533L418.11 409.375L418.096 409.389L418.106 409.419L418.11 409.412L418.466 451.063H426.903L427.568 404.056L432.626 401.664L434.053 447.258H442.228L442.383 397.934V397.922V397.048L442.457 397.013L442.902 375.757L446.458 381.673L447.053 397.854C447.095 399.074 448.054 400.063 449.271 400.152L449.299 400.154L449.271 401.038L449.303 400.154L449.453 400.165L449.481 400.167L449.453 401.051ZM442.832 397.815C442.738 397.86 442.635 397.888 442.523 397.896L442.509 397.901C442.57 397.899 442.687 397.884 442.832 397.815ZM423.253 353.553C425.293 355.259 427.834 356.277 430.576 356.277C433.927 356.277 436.922 354.752 439.018 352.306C441.156 351.062 442.645 348.587 442.696 345.74C442.719 344.503 442.467 343.336 442.003 342.309C441.32 335.806 436.168 330.705 430.034 330.705C425.743 330.705 422.041 333.201 420.062 336.926C417.671 337.818 415.986 340.352 416.052 343.335C416.094 345.392 416.959 347.236 418.288 348.475C416.992 349.799 415.775 351.558 415.092 353.843C414.952 354.304 415.209 354.791 415.668 354.94C421.007 356.673 422.144 357.283 422.144 357.283L422.093 357.245L422.635 357.433C422.898 357.433 423.146 357.318 423.314 357.118C423.482 356.919 423.553 356.655 423.511 356.397C423.511 356.397 423.305 355.219 423.253 353.553ZM495.283 384.071L495.007 384.051L495.002 384.05C493.084 383.889 491.61 382.286 491.61 380.361V367.922L491.605 365.407L489.017 360.989C489.546 369.537 489.743 377.368 489.565 384.414C489.565 384.489 489.551 384.561 489.532 384.631L489.209 440.651C489.209 441.138 488.812 441.531 488.325 441.531H480.15C479.668 441.531 479.275 441.147 479.261 440.665L478.128 394.842L474.642 396.394L474.011 444.465C474.006 444.947 473.608 445.335 473.126 445.335H464.689C464.203 445.335 463.809 444.942 463.805 444.46L463.416 395.545C463.388 395.458 463.374 395.365 463.374 395.269L463.304 378.603L453.398 371.854C451.063 370.264 449.491 367.782 449.046 364.994C448.648 362.496 449.186 359.95 450.543 357.84L450.454 358.021L450.688 357.642C450.862 357.436 451.236 357.09 451.236 357.09C451.25 357.076 451.264 357.064 451.283 357.052L463.159 347.529C465.284 345.827 467.806 344.692 470.487 344.231L471.259 344.098C465.742 343.244 461.315 338.343 460.908 332.041C460.44 324.761 465.532 318.416 472.223 317.843L472.298 317.837C472.34 317.828 472.382 317.819 472.424 317.812L472.719 317.795L472.794 317.808L472.799 317.808C479.266 317.579 484.815 322.898 485.274 329.99C485.639 335.71 482.579 340.852 478.002 343.072C484.694 342.724 491.132 346.019 494.74 351.802L499.649 359.673C500.178 360.526 500.538 361.464 500.716 362.43C500.955 363.2 501.043 364.025 500.964 364.869L499.462 380.518C499.289 382.275 497.992 383.654 496.345 383.998C496.261 384.016 496.172 384.032 496.083 384.044C495.798 384.084 495.508 384.093 495.208 384.068C495.232 384.07 495.255 384.071 495.283 384.071C495.756 384.071 496.149 383.697 496.167 383.222C496.167 383.192 496.167 383.161 496.167 383.131C497.44 382.864 498.446 381.795 498.577 380.433L500.08 364.785C500.154 364.043 500.07 363.319 499.855 362.645C499.7 361.764 499.378 360.914 498.896 360.142L493.987 352.271C490.178 346.165 483.056 342.971 475.962 344.189L470.637 345.105C468.1 345.54 465.719 346.612 463.711 348.221L451.835 357.743C451.835 357.743 451.33 358.205 451.292 358.319C450.052 360.247 449.556 362.573 449.921 364.855C450.323 367.402 451.765 369.669 453.894 371.122L464.188 378.133L464.259 395.265L464.301 395.279L464.305 396.123L464.301 396.165L464.31 396.158L464.689 444.451H473.126L473.763 395.816L478.98 393.493L480.15 440.646H488.325L488.643 385.322H488.648C488.947 385.322 489.209 385.175 489.368 384.95V384.952C489.214 385.137 488.989 385.26 488.737 385.276L488.648 385.322L488.643 385.312L488.648 384.436L488.68 384.392C488.882 376.352 488.601 367.287 487.88 357.298L492.489 365.166L492.494 367.921V380.361C492.494 381.825 493.617 383.045 495.077 383.168L495.283 383.185C495.512 383.205 495.742 383.198 495.962 383.167C495.962 383.18 495.962 383.192 495.962 383.205C495.943 383.609 495.662 383.94 495.283 384.029V384.071ZM464.231 396.152L464.217 396.15C464.137 396.147 464.058 396.132 463.983 396.108C464.1 396.146 464.188 396.152 464.231 396.152ZM472.766 318.695C472.705 318.678 472.64 318.674 472.574 318.685C472.527 318.693 472.48 318.703 472.434 318.714L472.298 318.725C466.06 319.26 461.353 325.201 461.793 331.984C462.228 338.767 467.647 343.841 473.88 343.306C480.117 342.772 484.825 336.831 484.389 330.048C483.964 323.435 478.802 318.447 472.766 318.695ZM463.524 369.023L460.857 366.439C460.833 366.418 460.815 366.401 460.787 366.385L458.297 363.979L464.235 360.079C464.16 360.631 464.123 361.194 464.123 361.766L464.156 369.635L463.524 369.023ZM461.404 365.748L461.474 365.803L463.262 367.537L463.239 361.793L459.71 364.111L461.404 365.748Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_87"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_88"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_89"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_91",
  d: "M396.841 405.352V346.741",
  stroke: "#8496B9",
  strokeWidth: 0.632595,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_90"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_92",
  d: "M396.986 362.847C398.364 362.847 399.481 361.73 399.481 360.351C399.481 358.973 398.364 357.856 396.986 357.856C395.607 357.856 394.49 358.973 394.49 360.351C394.49 361.73 395.607 362.847 396.986 362.847Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897345,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_91"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_93",
  d: "M410.309 414.689L396.841 405.351L384.871 418.494",
  stroke: "#8496B9",
  strokeWidth: 0.898611,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_92"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_94",
  d: "M396.841 405.351L401.263 425.935",
  stroke: "#8496B9",
  strokeWidth: 0.898611,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_93"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_94"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_95",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M409.434 332.789L411.221 353.947L382.777 364.012L380.989 342.854L409.434 332.789Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.00959,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_95"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_96",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M406.078 338.035L407.352 351.293L386.222 358.892L385.099 345.454L406.078 338.035Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.9947,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_96"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_97",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M409.433 332.789L405.721 330.092L377.276 340.158L380.988 342.854L409.433 332.789Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.659256,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_97"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_98",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M377.28 340.139L379.068 361.297L382.776 364.012L380.988 342.854L377.28 340.139Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.520889,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_98"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_99"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_100"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_101"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_99",
  d: "M473.901 343.305C480.141 342.77 484.845 336.834 484.408 330.046C483.971 323.258 478.558 318.189 472.318 318.724C466.078 319.258 461.374 325.195 461.811 331.983C462.248 338.77 467.661 343.84 473.901 343.305Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_100",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.318 318.724C478.553 318.189 483.971 323.262 484.408 330.046C484.845 336.829 480.137 342.77 473.901 343.305C467.666 343.839 462.248 338.766 461.811 331.983C461.374 325.199 466.082 319.258 472.318 318.724ZM472.393 319.606C466.614 320.101 462.29 325.639 462.695 331.926C463.099 338.191 468.066 342.916 473.826 342.422C479.605 341.927 483.929 336.39 483.524 330.103C483.12 323.837 478.153 319.113 472.393 319.606Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_102"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_101",
  d: "M469.58 327.128C469.58 327.128 469.861 319.602 472.667 319.122",
  stroke: "#8496B9",
  strokeWidth: 0.793317,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_103"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_102",
  d: "M472.295 327.155C472.295 327.155 472.555 319.903 475.361 319.431",
  stroke: "#8496B9",
  strokeWidth: 0.804165,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_104"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_103",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M473.174 327.596C473.994 327.625 474.657 328.285 474.689 329.108C474.761 330.972 474.885 334.19 474.961 336.16C474.977 336.598 474.812 337.023 474.502 337.333C474.193 337.643 473.768 337.81 473.331 337.794C472.031 337.747 470.251 337.683 469.011 337.638C468.185 337.608 467.528 336.949 467.497 336.125C467.425 334.262 467.301 331.043 467.225 329.073C467.208 328.636 467.374 328.211 467.683 327.901C467.993 327.591 468.417 327.423 468.855 327.439C470.155 327.486 471.935 327.551 473.174 327.596Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_104",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M473.207 326.711C474.489 326.757 475.523 327.787 475.573 329.074L475.845 336.126C475.871 336.81 475.612 337.474 475.127 337.958C474.642 338.443 473.979 338.704 473.298 338.679L468.978 338.523C467.69 338.476 466.662 337.445 466.612 336.159L466.34 329.107C466.314 328.423 466.574 327.759 467.052 327.275C467.537 326.79 468.201 326.529 468.887 326.554L473.207 326.711ZM473.174 327.596L468.854 327.439C468.417 327.423 467.993 327.591 467.683 327.901C467.374 328.211 467.208 328.636 467.225 329.073L467.497 336.125C467.528 336.949 468.185 337.608 469.011 337.638L473.331 337.794C473.768 337.81 474.192 337.643 474.502 337.333C474.812 337.023 474.977 336.598 474.961 336.16L474.689 329.108C474.657 328.285 473.994 327.625 473.174 327.596Z",
  fill: "#8496B9"
})))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_105"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_106"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_107"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_105",
  d: "M422.257 350.083C418.916 350.083 416.143 347.061 416.064 343.333C415.985 339.606 418.63 336.583 421.972 336.583C425.314 336.583 428.086 339.606 428.165 343.333C428.244 347.061 425.599 350.083 422.257 350.083Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_106",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.972 336.583C425.311 336.583 428.086 339.608 428.165 343.333C428.244 347.059 425.597 350.083 422.257 350.083C418.918 350.083 416.143 347.059 416.064 343.333C415.985 339.608 418.633 336.583 421.972 336.583ZM421.972 337.469C419.103 337.469 416.882 340.114 416.95 343.315C417.018 346.537 419.369 349.197 422.257 349.197C425.126 349.197 427.347 346.553 427.279 343.352C427.211 340.13 424.86 337.469 421.972 337.469Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_108"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_107",
  d: "M430.588 356.274C424.085 356.274 418.692 350.55 418.543 343.488C418.393 336.426 423.544 330.702 430.048 330.702C436.551 330.702 441.944 336.426 442.093 343.488C442.243 350.55 437.092 356.274 430.588 356.274Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_108",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M430.048 330.702C436.546 330.702 441.944 336.431 442.093 343.488C442.243 350.545 437.087 356.274 430.588 356.274C424.09 356.274 418.692 350.545 418.543 343.488C418.393 336.431 423.549 330.702 430.048 330.702ZM430.047 331.588C424.026 331.588 419.29 336.931 419.428 343.469C419.567 350.029 424.548 355.388 430.588 355.388C436.61 355.388 441.346 350.045 441.208 343.507C441.069 336.947 436.088 331.588 430.047 331.588Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_109"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_109",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423.823 345.85C423.823 345.85 417.804 347.911 415.954 354.096C422.074 356.082 422.65 356.546 422.65 356.546C422.65 356.546 421.555 350.143 423.823 345.85Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_110",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.604 346.265C422.458 350.329 423.526 356.396 423.526 356.396C423.57 356.654 423.496 356.918 423.33 357.117C423.16 357.317 422.911 357.432 422.65 357.432L422.104 357.243L422.157 357.281C422.157 357.281 421.023 356.671 415.679 354.939C415.221 354.79 414.968 354.304 415.104 353.842C417.088 347.218 423.535 345.012 423.535 345.012C423.88 344.895 424.259 344.999 424.495 345.275C424.73 345.551 424.774 345.943 424.604 346.265ZM423.823 345.85C423.823 345.85 417.804 347.911 415.954 354.096C422.074 356.082 422.65 356.546 422.65 356.546C422.65 356.546 421.555 350.143 423.823 345.85Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_110"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_111",
  d: "M437.475 338.942C437.475 338.942 437.017 331.443 429.959 331.203",
  stroke: "#8496B9",
  strokeWidth: 0.979954,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_111"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_112",
  d: "M434.753 338.945C434.753 338.945 434.605 332.286 426.003 332.073",
  stroke: "#8496B9",
  strokeWidth: 0.953001,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_112"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_113",
  d: "M435.914 353.157C432.236 353.157 429.316 349.836 429.391 345.738C429.467 341.64 432.51 338.318 436.188 338.318C439.866 338.318 442.786 341.64 442.711 345.738C442.635 349.836 439.592 353.157 435.914 353.157Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_114",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M436.188 338.318C439.863 338.318 442.786 341.643 442.711 345.738C442.635 349.833 439.59 353.157 435.914 353.157C432.239 353.157 429.316 349.833 429.391 345.738C429.467 341.643 432.512 338.318 436.188 338.318ZM436.188 339.204C432.965 339.204 430.343 342.164 430.277 345.754C430.211 349.326 432.708 352.272 435.914 352.272C439.137 352.272 441.759 349.312 441.825 345.721C441.891 342.15 439.394 339.204 436.188 339.204Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_113"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_115",
  d: "M437.526 351.546C434.877 351.546 432.773 349.153 432.828 346.201C432.882 343.25 435.074 340.857 437.723 340.857C440.373 340.857 442.476 343.25 442.422 346.201C442.367 349.153 440.176 351.546 437.526 351.546Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_116",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M437.723 340.857C440.371 340.857 442.476 343.252 442.422 346.201C442.367 349.151 440.174 351.546 437.526 351.546C434.879 351.546 432.773 349.151 432.828 346.201C432.882 343.252 435.076 340.857 437.723 340.857ZM437.723 341.743C435.528 341.743 433.758 343.772 433.713 346.218C433.668 348.644 435.348 350.66 437.526 350.66C439.721 350.66 441.491 348.631 441.536 346.185C441.581 343.759 439.901 341.743 437.723 341.743Z",
  fill: "#8496B9"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_114"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_117",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M417.922 376.611L415.158 380.392L415.128 380.38C413.85 382.09 412.008 383.314 409.908 383.821C407.412 384.424 404.779 383.958 402.641 382.537L390.359 374.376C389.668 373.917 389.191 373.198 389.035 372.383C388.879 371.568 389.057 370.724 389.53 370.042L389.717 369.773C390.312 368.914 391.433 368.599 392.388 369.021L407.756 375.813L416.815 364.119C419.221 361.013 422.737 358.961 426.624 358.394L429.514 357.973C436.732 356.92 443.857 360.401 447.463 366.742L452.168 375.016C452.351 375.339 452.508 375.673 452.637 376.016C453.652 377.466 454.135 379.237 453.978 381.024L452.524 397.561C452.386 399.118 451.025 400.277 449.466 400.164L449.285 400.151C448.068 400.063 447.113 399.073 447.068 397.854L446.473 381.672L442.917 375.756L442.472 397.013L442.399 397.047L442.245 447.256H434.066L432.642 401.663L427.584 404.056L426.918 451.061H418.483L418.12 408.533L418.05 408.565L417.922 376.611Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_118",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M414.565 381.063C413.334 382.416 411.716 383.384 409.908 383.821C407.412 384.424 404.779 383.958 402.641 382.537L390.359 374.376C389.668 373.917 389.191 373.198 389.035 372.383C388.879 371.568 389.057 370.724 389.53 370.042L389.717 369.773C390.312 368.914 391.433 368.599 392.388 369.021L407.756 375.813L416.815 364.119C419.221 361.013 422.737 358.961 426.624 358.394L429.514 357.973C436.732 356.92 443.857 360.401 447.463 366.742L452.168 375.016C452.351 375.339 452.508 375.673 452.637 376.016C453.652 377.466 454.135 379.237 453.978 381.024L452.524 397.561C452.413 398.814 451.51 399.81 450.349 400.091C450.314 399.662 449.971 399.313 449.53 399.281C450.607 399.359 451.547 398.558 451.641 397.483L453.095 380.947C453.234 379.369 452.808 377.805 451.912 376.524C451.869 376.464 451.834 376.398 451.808 376.328C451.695 376.028 451.558 375.736 451.398 375.454L446.693 367.18C443.267 361.157 436.499 357.849 429.642 358.849L426.752 359.271C423.092 359.804 419.781 361.737 417.516 364.661L408.457 376.355C408.207 376.677 407.771 376.787 407.399 376.623L392.03 369.831C391.463 369.581 390.798 369.768 390.445 370.278L390.258 370.547C389.921 371.033 389.793 371.635 389.905 372.217C390.016 372.798 390.357 373.311 390.849 373.638L403.131 381.8C405.064 383.084 407.444 383.505 409.7 382.96C411.598 382.502 413.263 381.395 414.419 379.849C414.218 380.118 414.186 380.477 414.337 380.777C414.393 380.889 414.471 380.986 414.565 381.063ZM418.127 409.374L418.12 408.533L418.05 408.565L417.922 376.611L415.158 380.392L415.128 380.38C414.953 380.615 414.767 380.84 414.571 381.056C414.489 380.983 414.42 380.895 414.368 380.793C414.217 380.496 414.246 380.139 414.443 379.87L417.207 376.088C417.433 375.779 417.831 375.651 418.196 375.769C418.559 375.886 418.806 376.225 418.808 376.608L418.936 408.562L418.127 409.374ZM442.396 397.933L442.245 447.256H434.066L432.642 401.663L427.584 404.056L426.918 451.061H418.483L418.127 409.411L419.005 408.525L419.361 450.175H426.045L426.698 404.043C426.703 403.705 426.9 403.399 427.205 403.255L432.263 400.862C432.533 400.734 432.849 400.752 433.104 400.907C433.359 401.063 433.518 401.337 433.527 401.635L434.925 446.37H441.362L441.513 397.045C441.512 397.28 441.605 397.506 441.771 397.673C441.937 397.839 442.162 397.932 442.396 397.933ZM449.317 400.153L449.285 400.151C448.068 400.063 447.113 399.073 447.068 397.854L446.473 381.672L442.917 375.756L442.472 397.013L442.399 397.047L442.396 397.921L442.39 397.894C442.182 397.875 441.987 397.783 441.84 397.633C441.673 397.462 441.582 397.232 441.587 396.994L442.032 375.738C442.04 375.343 442.308 375.002 442.689 374.901C443.071 374.799 443.473 374.962 443.676 375.3L447.232 381.216C447.309 381.344 447.352 381.49 447.358 381.64L447.953 397.821C447.981 398.589 448.583 399.212 449.349 399.268L449.317 400.153ZM449.496 400.166C449.486 400.166 449.476 400.165 449.466 400.164L449.319 400.153L449.354 399.268L449.526 399.28L449.496 400.166ZM418.169 409.42C418.231 409.419 418.348 409.405 418.496 409.334L418.169 409.42Z",
  fill: "#8496B9"
})))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_115"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_119",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.208 378.132L453.915 371.12C451.783 369.668 450.345 367.401 449.939 364.853C449.576 362.571 450.07 360.245 451.31 358.317C451.35 358.203 451.419 358.101 451.51 358.019C451.594 357.898 451.682 357.779 451.772 357.662L451.855 357.741L463.733 348.219C465.739 346.61 468.122 345.538 470.656 345.103L475.983 344.188C483.075 342.969 490.199 346.163 494.007 352.269L498.916 360.14C499.398 360.912 499.721 361.763 499.877 362.643C500.089 363.317 500.171 364.042 500.1 364.783L498.597 380.431C498.437 382.097 496.968 383.324 495.301 383.184L495.096 383.166C493.637 383.044 492.515 381.824 492.515 380.36L492.515 367.919L492.511 365.164L487.901 357.297C488.618 367.285 488.9 376.35 488.699 384.39L488.668 384.434L488.345 440.643H480.167L479.001 393.491L473.784 395.814L473.145 444.449H464.709L464.32 395.278L464.277 395.264L464.208 378.132ZM464.252 360.077L458.315 363.978L464.175 369.634L464.143 361.764C464.141 361.192 464.178 360.629 464.252 360.077Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_120",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.327 396.122L464.32 395.278L464.277 395.264L464.208 378.132L453.915 371.12C451.783 369.668 450.345 367.401 449.939 364.853C449.576 362.571 450.07 360.245 451.31 358.317C451.35 358.203 451.419 358.101 451.51 358.019C451.594 357.898 451.682 357.779 451.772 357.662L451.855 357.741L463.733 348.219C465.739 346.61 468.122 345.538 470.656 345.103L475.983 344.188C483.075 342.969 490.199 346.163 494.007 352.269L498.916 360.14C499.398 360.912 499.721 361.763 499.877 362.643C500.089 363.317 500.171 364.042 500.1 364.783L498.597 380.431C498.466 381.794 497.459 382.862 496.185 383.13C496.159 382.695 495.817 382.338 495.375 382.301C496.559 382.4 497.602 381.529 497.716 380.347L499.218 364.698C499.278 364.078 499.209 363.473 499.032 362.909C499.02 362.873 499.011 362.835 499.005 362.797C498.868 362.028 498.586 361.284 498.165 360.609L493.256 352.738C489.638 346.937 482.87 343.903 476.133 345.061L470.806 345.976C468.42 346.386 466.176 347.396 464.287 348.91L452.408 358.432C452.351 358.479 452.287 358.517 452.22 358.548C452.193 358.584 452.163 358.619 452.13 358.651C452.11 358.701 452.084 358.75 452.055 358.796C450.933 360.542 450.485 362.648 450.814 364.714C451.181 367.02 452.484 369.073 454.414 370.388L464.707 377.399C464.948 377.564 465.093 377.836 465.094 378.128L465.163 395.26L464.331 396.095L464.327 396.122ZM488.662 385.32L488.345 440.643H480.167L479.001 393.491L473.784 395.814L473.145 444.449H464.709L464.327 396.156L465.206 395.271L465.588 443.563H472.27L472.898 395.803C472.903 395.457 473.108 395.145 473.423 395.005L478.641 392.682C478.912 392.562 479.224 392.584 479.474 392.742C479.725 392.9 479.88 393.173 479.887 393.469L481.031 439.757H487.464L487.782 384.429C487.781 384.665 487.873 384.892 488.039 385.059C488.205 385.225 488.429 385.319 488.662 385.32ZM495.982 383.165C495.76 383.196 495.532 383.203 495.301 383.184L495.096 383.166C493.637 383.044 492.515 381.824 492.515 380.36L492.515 367.919L492.511 365.164L487.901 357.297C488.618 367.285 488.9 376.35 488.699 384.39L488.668 384.434L488.663 385.31L488.644 385.274C488.426 385.261 488.219 385.167 488.065 385.009C487.898 384.838 487.808 384.607 487.814 384.368C488.015 376.353 487.733 367.317 487.018 357.36C486.988 356.95 487.245 356.573 487.639 356.451C488.032 356.329 488.457 356.494 488.666 356.849L493.275 364.716C493.354 364.852 493.396 365.006 493.396 365.163L493.401 367.918L493.401 367.919L493.401 380.36C493.401 381.364 494.17 382.2 495.17 382.284L495.176 382.284L495.37 382.301L495.369 382.324C495.728 382.44 495.981 382.776 495.982 383.165ZM465.13 360.196C465.061 360.708 465.027 361.23 465.029 361.761L465.061 369.63C465.062 369.986 464.85 370.309 464.522 370.448C464.195 370.588 463.816 370.518 463.559 370.271L457.701 364.615C457.507 364.428 457.409 364.164 457.434 363.896C457.459 363.628 457.604 363.385 457.829 363.238L463.766 359.337C464.056 359.147 464.431 359.143 464.724 359.328C465.018 359.513 465.177 359.852 465.13 360.196ZM464.252 360.077L458.315 363.978L464.175 369.634L464.143 361.764C464.141 361.192 464.178 360.629 464.252 360.077Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_116"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_121",
  d: "M458.114 373.437C458.114 373.437 462.316 376.3 465.475 378.453C466.149 378.912 467.022 378.962 467.744 378.583C468.467 378.204 468.921 377.457 468.925 376.641C468.927 376.328 468.928 376.036 468.93 375.783C468.933 375.2 468.698 374.641 468.279 374.235C466.307 372.323 460.565 366.755 460.565 366.755",
  stroke: "#8496B9",
  strokeWidth: 0.663177,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Audio"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_117"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_118"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_119"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_122",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M588.123 287.611C588.121 286.667 588.61 285.789 589.414 285.292C590.216 284.796 591.22 284.75 592.065 285.172C595.756 287.017 601.189 289.735 604.549 291.415C606.404 292.343 607.577 294.238 607.579 296.312C607.582 299.276 607.587 303.114 607.587 303.114L588.129 293.385C588.129 293.385 588.126 290.363 588.123 287.611Z",
  stroke: "#8496B9",
  strokeWidth: 0.8987,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_120"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_123",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M596.394 390.566V359.356L610.69 352.209V383.419L596.394 390.566Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_121"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_124",
  d: "M607.808 341.584V350.671",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_122"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_125",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M570.49 346.501L596.394 359.356L610.69 352.209L584.785 339.353L570.49 346.501Z",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_123"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_126",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M596.394 390.566V359.453L570.49 346.501V377.615L596.394 390.566Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_124"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_127",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M567.113 314.863L593.018 327.816L596.394 326.127L570.49 313.173L567.113 314.863Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_125"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_128",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M570.49 298.877L596.394 311.831L610.69 304.683L584.785 291.73L570.49 298.877Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_126"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_129",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M596.394 326.126V311.831L610.69 304.683V318.979L596.394 326.126Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_127"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_130",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M596.394 326.126V311.831L570.49 298.877V313.175L596.394 326.126Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_128"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_131",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M593.018 351.96V327.816L610.69 318.979V343.123L593.018 351.96Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_129"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_132",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M593.018 346.204V327.816L567.113 314.863V333.25L593.018 346.204Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_130"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_133",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.33 341.666C589.552 341.777 589.816 341.766 590.028 341.635C590.238 341.503 590.367 341.273 590.367 341.025C590.367 338.581 590.367 332.928 590.367 330.531C590.367 329.855 589.985 329.235 589.379 328.931C585.896 327.191 574.227 321.355 570.671 319.577C570.449 319.467 570.185 319.479 569.973 319.61C569.762 319.74 569.634 319.97 569.634 320.219C569.634 322.664 569.634 328.316 569.634 330.712C569.634 331.39 570.016 332.01 570.622 332.312C574.103 334.054 585.773 339.888 589.33 341.666Z",
  stroke: "#8496B9",
  strokeWidth: 0.898155,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_131"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_132"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_134",
  d: "M573.961 304.294V311.461",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_133"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_135",
  d: "M576.695 305.646V312.813",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_134"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_136",
  d: "M579.43 306.998V314.165",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_135"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_137",
  d: "M582.165 308.35V315.517",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_136"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_138",
  d: "M584.899 309.702V316.869",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_137"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_139",
  d: "M587.634 311.054V318.221",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_138"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_140",
  d: "M590.369 312.406V319.573",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_139"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_141",
  d: "M593.103 313.758V320.925",
  stroke: "#8496B9",
  strokeWidth: 0.898082,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_140"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_142",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M555.849 341.761L581.753 354.712L593.017 346.203L567.113 333.252L555.849 341.761Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_141"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_143",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M581.753 357.591V354.712L593.017 346.203V351.96L581.753 357.591Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_142"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_144",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M581.753 357.591V354.712L555.849 341.761V344.64L581.753 357.591Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898394,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_143"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_144"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_145",
  d: "M608.87 387.197C613.239 384.873 616.781 377.981 616.781 371.806C616.781 365.63 613.239 362.508 608.87 364.832C604.501 367.157 600.959 374.048 600.959 380.224C600.959 386.4 604.501 389.522 608.87 387.197Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.20613,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_145"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_146",
  d: "M610.672 387.811C615.041 385.486 618.583 378.595 618.583 372.419C618.583 366.243 615.041 363.121 610.672 365.446C606.303 367.771 602.761 374.662 602.761 380.838C602.761 387.014 606.303 390.136 610.672 387.811Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.20613,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_146"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_147",
  d: "M610.671 379.94C611.965 379.252 613.014 377.211 613.014 375.381C613.014 373.552 611.965 372.628 610.671 373.316C609.377 374.005 608.328 376.046 608.328 377.875C608.328 379.704 609.377 380.629 610.671 379.94Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.20704,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_147"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_148"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_148",
  d: "M536.785 386.052C536.785 386.052 540.776 383.846 544.417 381.837C545.528 381.226 546.883 381.295 547.924 382.013C548.966 382.735 549.508 383.979 549.328 385.233C548.211 392.945 546.527 404.621 546.527 404.621L551.767 402.017C551.767 402.017 555.338 387.035 557.725 377.038C558.192 375.082 557.65 373.026 556.284 371.554C554.918 370.081 552.904 369.391 550.922 369.709C550.863 369.715 550.826 369.72 550.81 369.725C550.805 369.725 550.8 369.725 550.789 369.731C550.268 369.885 529.632 376.092 529.632 376.092",
  stroke: "#8496B9",
  strokeWidth: 0.900513,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_149"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_150"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_149",
  d: "M527.145 403.835L546.837 395.63",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_151"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_150",
  d: "M527.145 385.783L547.329 413.928",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_152"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_151",
  d: "M551.28 394.17L560.667 407.259",
  stroke: "#8496B9",
  strokeWidth: 0.898826,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_153"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_152",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M522.887 385.863L543.071 395.956L559.17 387.906L538.986 377.813L522.887 385.863Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_154"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_153",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M543.071 398.274L543.056 395.534L559.17 387.906L559.139 390.533L543.071 398.274Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_155"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_154",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M543.071 398.274V395.542L522.887 385.449V388.181L543.071 398.274Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_156"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_155",
  d: "M540.877 337.707C534.657 338.442 528.852 333.577 527.911 326.841C526.97 320.104 531.249 314.047 537.468 313.311C543.688 312.576 549.493 317.441 550.434 324.178C551.375 330.914 547.096 336.972 540.877 337.707Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_156",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.468 313.311C543.683 312.577 549.493 317.446 550.434 324.178C551.375 330.91 547.092 336.972 540.877 337.707C534.662 338.442 528.852 333.573 527.911 326.841C526.97 320.108 531.253 314.046 537.468 313.311ZM537.572 314.191C531.831 314.87 527.92 320.5 528.788 326.718C529.66 332.957 535.012 337.508 540.773 336.827C546.514 336.149 550.425 330.519 549.556 324.3C548.685 318.061 543.332 313.51 537.572 314.191Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_157"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_157",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M531.921 327.702C531.921 327.702 525.902 329.763 524.052 335.948C530.172 337.934 530.748 338.398 530.748 338.398C530.748 338.398 529.653 331.995 531.921 327.702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_158",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M532.702 328.117C530.556 332.181 531.624 338.248 531.624 338.248C531.668 338.506 531.594 338.77 531.428 338.969C531.258 339.169 531.009 339.284 530.748 339.284L530.203 339.095L530.255 339.133C530.255 339.133 529.121 338.523 523.778 336.791C523.32 336.642 523.067 336.156 523.202 335.694C525.186 329.07 531.633 326.864 531.633 326.864C531.978 326.747 532.357 326.851 532.593 327.127C532.828 327.403 532.872 327.795 532.702 328.117ZM531.921 327.702C531.921 327.702 525.902 329.763 524.052 335.948C530.172 337.934 530.748 338.398 530.748 338.398C530.748 338.398 529.653 331.995 531.921 327.702Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_158"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_159",
  d: "M541.921 320.813C541.921 320.813 540.324 313.525 537.238 313.833",
  stroke: "#8496B9",
  strokeWidth: 0.801516,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_159"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_160",
  d: "M539.019 321.593C539.019 321.593 537.422 314.305 534.336 314.613",
  stroke: "#8496B9",
  strokeWidth: 0.801516,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_160"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_161",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M538.423 322.174C537.626 322.369 537.11 323.148 537.245 323.961C537.551 325.801 538.079 328.978 538.402 330.923C538.474 331.355 538.722 331.738 539.087 331.979C539.453 332.22 539.902 332.298 540.328 332.195C541.592 331.886 543.322 331.464 544.527 331.17C545.33 330.974 545.84 330.195 545.705 329.383C545.399 327.543 544.871 324.365 544.548 322.42C544.477 321.989 544.229 321.606 543.863 321.365C543.497 321.124 543.048 321.045 542.622 321.149C541.359 321.458 539.628 321.88 538.423 322.174Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_162",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M538.213 321.314L542.412 320.289C543.079 320.126 543.782 320.248 544.354 320.625C544.921 321.003 545.309 321.601 545.422 322.276L546.578 329.238C546.789 330.507 545.99 331.724 544.737 332.03L540.538 333.055C539.877 333.216 539.174 333.094 538.602 332.718C538.029 332.341 537.641 331.743 537.529 331.068L536.372 324.106C536.161 322.836 536.967 321.618 538.213 321.314ZM538.423 322.174C537.626 322.369 537.11 323.148 537.245 323.961L538.402 330.923C538.474 331.355 538.722 331.738 539.087 331.979C539.453 332.22 539.902 332.299 540.328 332.195L544.527 331.17C545.33 330.974 545.84 330.196 545.705 329.383L544.548 322.421C544.477 321.989 544.229 321.606 543.863 321.365C543.497 321.124 543.048 321.045 542.623 321.149L538.423 322.174Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_161"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_163",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M551.754 357.053L556.041 362.71L556.081 362.665C557.12 363.791 558.535 364.513 560.072 364.685C561.823 364.88 563.577 364.345 564.92 363.205L578.521 351.663C579.167 351.114 579.562 350.327 579.616 349.481C579.669 348.635 579.377 347.803 578.805 347.178L578.564 346.914C577.902 346.19 576.823 346.029 575.979 346.529L561.139 355.302L552.72 344.536C550.397 341.566 547.051 339.566 543.335 338.927L542.518 338.787C538.974 338.179 535.342 339.175 532.605 341.507C530.915 342.946 529.674 344.803 528.981 346.86C528.558 347.635 528.291 348.51 528.222 349.445C527.735 357.832 527.482 368.365 527.354 375.447C527.254 380.217 530.024 384.583 534.383 386.524L542.982 390.352C544.557 391.053 546.337 391.145 547.976 390.61L548.779 390.347L548.79 390.369L549.035 390.264L549.219 390.204C549.471 390.121 549.709 390.012 549.93 389.879L558.167 386.346C559.113 385.94 560.194 385.994 561.094 386.492C561.995 386.991 562.615 387.877 562.774 388.894L565.395 405.656L571.293 402.958L569.624 378.644C569.424 375.734 567.337 373.301 564.492 372.66L564.296 372.616C563.26 372.383 562.183 372.404 561.156 372.676L551.682 375.189L551.754 357.053Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_164",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M556.725 363.273C556.732 363.265 556.739 363.258 556.746 363.249L556.715 363.265C556.491 363.08 556.279 362.88 556.081 362.665L556.041 362.71L551.754 357.053L551.682 375.189L561.156 372.676C562.183 372.404 563.26 372.383 564.296 372.616L564.492 372.66C567.337 373.301 569.424 375.734 569.624 378.644L571.293 402.958L565.395 405.656L562.774 388.894C562.615 387.877 561.995 386.991 561.094 386.492C560.194 385.994 559.113 385.94 558.167 386.346L549.93 389.879C549.709 390.012 549.471 390.121 549.219 390.204L549.085 390.247L548.944 389.362C549.132 389.3 549.31 389.218 549.475 389.119C549.51 389.099 549.545 389.081 549.581 389.065L557.818 385.532C559.015 385.018 560.383 385.087 561.523 385.717C562.663 386.348 563.448 387.47 563.65 388.757L566.09 404.364L570.368 402.408L568.74 378.704C568.567 376.186 566.76 374.079 564.297 373.525L564.492 373.547L564.192 373.496C564.164 373.492 564.135 373.487 564.107 373.482L564.101 373.481C563.204 373.279 562.272 373.297 561.383 373.532L551.909 376.046C551.643 376.117 551.359 376.059 551.141 375.891C550.922 375.722 550.795 375.462 550.796 375.186L550.869 357.05C550.87 356.67 551.114 356.333 551.474 356.213C551.834 356.093 552.231 356.215 552.46 356.518L556.707 362.122L556.732 362.064C557.627 363.035 558.846 363.657 560.171 363.804C561.679 363.973 563.19 363.512 564.347 362.53L577.948 350.987C578.411 350.595 578.693 350.03 578.732 349.425C578.77 348.819 578.561 348.224 578.151 347.776L577.91 347.512C577.531 347.097 576.913 347.005 576.43 347.291L561.59 356.065C561.207 356.291 560.716 356.198 560.441 355.848L552.022 345.082C549.835 342.285 546.684 340.402 543.184 339.8L542.368 339.66C539.083 339.096 535.717 340.019 533.18 342.181C531.613 343.515 530.463 345.237 529.82 347.142C529.804 347.191 529.783 347.238 529.759 347.283C529.396 347.949 529.166 348.701 529.106 349.504C528.62 357.879 528.368 368.393 528.24 375.463L528.24 375.466C528.147 379.879 530.71 383.919 534.744 385.715L543.342 389.543C544.717 390.155 546.27 390.235 547.701 389.768L548.504 389.505C548.09 389.64 547.836 390.056 547.904 390.486C547.912 390.533 547.923 390.578 547.937 390.622C546.309 391.144 544.545 391.048 542.982 390.352L534.383 386.524C530.024 384.583 527.254 380.217 527.354 375.447C527.482 368.365 527.735 357.832 528.222 349.445C528.291 348.51 528.558 347.635 528.981 346.86C529.674 344.803 530.915 342.946 532.605 341.507C535.342 339.175 538.974 338.179 542.518 338.787L543.335 338.927C547.051 339.566 550.397 341.566 552.72 344.536L561.139 355.302L575.979 346.529C576.823 346.029 577.902 346.19 578.564 346.914L578.805 347.178C579.377 347.803 579.669 348.635 579.616 349.481C579.562 350.327 579.167 351.114 578.521 351.663L564.92 363.205C563.577 364.345 561.823 364.88 560.072 364.685C558.833 364.546 557.673 364.05 556.725 363.273ZM547.941 390.621C547.934 390.597 547.928 390.572 547.922 390.547C547.838 390.135 548.054 389.721 548.441 389.555L548.686 389.45C548.299 389.615 548.083 390.03 548.167 390.442C548.174 390.475 548.183 390.507 548.193 390.539L547.976 390.61C547.964 390.614 547.952 390.617 547.941 390.621ZM548.905 390.319L548.764 389.42L548.938 389.363L549.082 390.248L549.035 390.264L548.905 390.319Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_162"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_165",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.237 382.896L541.467 370.952L521.281 360.859L522.053 372.803L542.237 382.896Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_163"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_166",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.237 382.896L543.054 395.55L522.868 385.457L522.053 372.803L542.237 382.896Z",
  stroke: "#8496B9",
  strokeWidth: 0.898163,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_164"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_167",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M557.551 386.571L559.357 387.474C559.368 387.481 559.384 387.489 559.395 387.497C559.522 387.578 559.602 387.718 559.602 387.87C559.602 387.872 559.602 387.873 559.602 387.875L559.57 390.502C559.57 390.67 559.469 390.823 559.32 390.896L554.271 393.328L553.511 396.505L561.016 406.964C561.159 407.163 561.111 407.44 560.915 407.583C560.713 407.725 560.436 407.679 560.293 407.48L553.24 397.645L552.183 402.085C552.151 402.213 552.066 402.321 551.949 402.38L546.709 404.982C546.56 405.056 546.385 405.041 546.252 404.944C546.119 404.848 546.05 404.685 546.076 404.522L547.198 396.735L543.249 398.637C543.127 398.697 542.983 398.696 542.861 398.634L541.867 398.138L537.786 399.84L547.676 413.634C547.82 413.832 547.772 414.109 547.575 414.251C547.373 414.394 547.097 414.348 546.959 414.15L536.946 400.19L527.3 404.207C527.077 404.301 526.817 404.195 526.721 403.969C526.631 403.743 526.737 403.484 526.96 403.39L536.415 399.451L531.897 393.153L522.677 388.541C522.523 388.467 522.432 388.313 522.432 388.146V385.536C522.422 385.508 522.416 385.479 522.416 385.45L520.827 360.852C520.817 360.694 520.891 360.543 521.024 360.455C521.157 360.367 521.327 360.356 521.47 360.428L527.624 363.505C527.768 358.753 527.922 353.786 528.209 349.409C528.273 348.474 528.544 347.599 528.969 346.824C529.66 344.767 530.903 342.91 532.593 341.471C535.33 339.139 538.96 338.143 542.505 338.752L543.324 338.892C547.038 339.531 550.387 341.53 552.709 344.501L561.127 355.267L568.02 351.192L555.637 345C555.488 344.925 555.393 344.771 555.393 344.603V341.725C555.393 341.586 555.457 341.456 555.568 341.372L566.654 332.994V314.827C566.654 314.673 566.734 314.531 566.867 314.45C566.877 314.443 566.888 314.437 566.899 314.43L570.034 312.865V298.843C570.034 298.689 570.114 298.546 570.242 298.466C570.252 298.459 570.268 298.453 570.279 298.446L584.575 291.299C584.697 291.237 584.846 291.237 584.968 291.299L587.673 292.65L587.668 287.576C587.663 286.478 588.231 285.458 589.167 284.88C590.097 284.303 591.266 284.25 592.249 284.741L604.733 290.983C606.736 291.985 608.007 294.035 608.007 296.276L608.017 302.822L610.876 304.252C610.887 304.257 610.898 304.264 610.908 304.271C611.041 304.351 611.121 304.494 611.121 304.647V343.087C611.121 343.256 611.025 343.409 610.876 343.484L608.235 344.802V350.468L610.871 351.777C610.887 351.783 610.898 351.79 610.908 351.797C611.041 351.877 611.121 352.019 611.121 352.173V363.61C612.067 363.514 612.949 363.68 613.725 364.074C613.826 364.123 613.922 364.175 614.012 364.231C614.549 364.295 615.059 364.45 615.532 364.687C617.605 365.735 619.013 368.466 619.013 372.383C619.013 378.716 615.346 385.781 610.866 388.165C608.968 389.175 607.209 389.213 605.79 388.496C605.689 388.447 605.599 388.395 605.503 388.338C604.967 388.275 604.456 388.12 603.989 387.882C603.782 387.779 603.58 387.658 603.388 387.522L596.58 390.928C596.453 390.99 596.309 390.99 596.182 390.928L570.279 377.975C570.13 377.901 570.034 377.747 570.034 377.58V358.82L564.906 363.169C563.567 364.31 561.813 364.845 560.059 364.649C558.821 364.51 557.662 364.015 556.711 363.237C556.711 363.234 556.705 363.232 556.705 363.229C556.477 363.044 556.264 362.844 556.068 362.629L556.031 362.674L551.742 357.018L551.694 369.154C553.533 369.106 555.324 369.848 556.594 371.217C557.21 371.881 557.667 372.655 557.96 373.485L561.143 372.64C562.169 372.368 563.248 372.348 564.284 372.581L564.481 372.625C567.324 373.266 569.413 375.698 569.609 378.608L571.283 402.923L565.384 405.62L562.764 388.858C562.605 387.842 561.983 386.955 561.085 386.457C560.181 385.958 559.102 385.904 558.156 386.31L557.551 386.571ZM527.343 375.914L522.533 373.509L523.282 385.123L523.288 385.125L529.267 382.136C528.076 380.314 527.391 378.168 527.343 375.914ZM537.254 399.101L540.82 397.615L533.598 394.003L537.254 399.101ZM607.353 350.029V345.245L602.549 347.646L607.353 350.029ZM588.55 287.575L588.555 293.076L607.13 302.361L607.119 296.277C607.119 294.371 606.04 292.628 604.334 291.775L591.85 285.533C591.144 285.179 590.304 285.217 589.634 285.633C588.959 286.049 588.55 286.785 588.55 287.575ZM531.355 334.051C531.286 336.378 531.61 338.212 531.61 338.212C531.653 338.47 531.584 338.734 531.414 338.933C531.244 339.133 530.999 339.248 530.739 339.248L530.191 339.06C530.191 339.062 530.245 339.098 530.245 339.098C530.245 339.098 529.107 338.488 523.766 336.755C523.309 336.606 523.054 336.12 523.192 335.658C524.207 332.263 526.397 330.029 528.289 328.657C528.119 328.058 527.986 327.44 527.895 326.805C527.146 321.434 529.724 316.488 533.949 314.336C534.018 314.227 534.14 314.15 534.278 314.136C534.31 314.133 534.347 314.13 534.384 314.128C535.336 313.697 536.367 313.405 537.456 313.276C543.669 312.541 549.478 317.411 550.418 324.142C551.359 330.875 547.076 336.937 540.863 337.672C537.27 338.096 533.811 336.649 531.355 334.051Z",
  stroke: "#8496B9",
  strokeWidth: 1.73309,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Aktor"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_165"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_168",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.909 152.303C270.027 152.208 270.121 152.082 270.178 151.934C270.31 151.594 270.219 151.207 269.95 150.96C270.166 151.157 270.357 151.377 270.52 151.615C270.574 151.693 270.625 151.773 270.673 151.855C270.998 152.409 271.183 153.042 271.2 153.697C271.228 154.74 270.833 155.751 270.102 156.496L259.785 167.03C258.098 168.753 255.771 169.697 253.36 169.635C252.112 169.604 250.899 169.303 249.802 168.772C249.11 168.591 248.463 168.218 247.946 167.66L244.958 164.435L245.459 180.674H246.571C247.992 180.674 249.159 181.794 249.218 183.213L249.562 191.507C249.592 192.229 249.327 192.931 248.827 193.452C248.328 193.973 247.637 194.267 246.915 194.267H245.931L248.124 243.713C248.134 243.955 248.045 244.189 247.878 244.364C247.711 244.539 247.481 244.638 247.238 244.638H239.244C238.782 244.638 238.397 244.282 238.361 243.821L234.288 191.243H231.286L233.141 243.721C233.15 243.961 233.06 244.195 232.893 244.367C232.726 244.54 232.496 244.638 232.256 244.638H224.011C223.541 244.638 223.153 244.271 223.126 243.802L220.114 190.408L220.114 190.405L218.866 166.886L217.815 168.427C217.768 168.496 217.712 168.558 217.648 168.61C217.504 168.808 217.35 169.001 217.191 169.187L217.185 169.194C215.951 170.63 214.303 171.679 212.441 172.181C209.846 172.879 207.076 172.448 204.816 170.993L191.912 162.685C191.056 162.134 190.454 161.265 190.239 160.27C190.106 159.656 190.127 159.025 190.293 158.431C190.321 158.328 190.354 158.226 190.391 158.126C190.488 157.866 190.612 157.616 190.764 157.38C190.588 157.652 190.576 157.999 190.731 158.284C190.825 158.457 190.973 158.59 191.146 158.668C191.018 159.125 191.003 159.611 191.104 160.083C191.27 160.848 191.733 161.516 192.391 161.94L205.296 170.248C207.346 171.568 209.857 171.958 212.211 171.325C213.9 170.87 215.394 169.919 216.513 168.617C216.576 168.665 216.645 168.705 216.719 168.736C216.816 168.775 216.92 168.798 217.028 168.802L216.719 168.736C216.647 168.703 216.579 168.661 216.518 168.611C216.709 168.389 216.888 168.157 217.055 167.916L217.083 167.928L219.612 164.222L220.998 190.358L224.011 243.752H232.256L230.368 190.358H235.107L239.244 243.752H247.239L245.006 193.382H246.915C247.396 193.382 247.856 193.185 248.188 192.838C248.521 192.492 248.698 192.024 248.678 191.544L248.334 183.251C248.294 182.305 247.516 181.56 246.571 181.56H244.613L244.592 181.305L244.021 162.78C244.013 162.543 243.999 162.308 243.979 162.075L248.595 167.058C249.013 167.508 249.542 167.803 250.104 167.935C251.114 168.438 252.232 168.721 253.383 168.75C255.547 168.805 257.637 167.957 259.152 166.411L269.469 155.877C270.032 155.303 270.337 154.525 270.315 153.72C270.301 153.216 270.159 152.73 269.909 152.303ZM191.221 158.434C191.073 158.353 190.948 158.231 190.864 158.077C190.752 157.872 190.728 157.634 190.789 157.414L190.767 157.375L190.894 157.18L190.897 157.174C191.71 155.914 193.314 155.427 194.689 156.022L209.246 162.319L217.98 149.098C219.751 146.416 222.706 144.752 225.918 144.629L229.92 144.474C236.92 144.205 243.643 147.225 248.091 152.636L254.125 159.975L265.963 150.669C267.102 149.775 268.72 149.835 269.788 150.813L269.793 150.817L269.946 150.957L269.935 150.986C270.087 151.221 270.12 151.518 270.016 151.787C269.967 151.916 269.889 152.028 269.791 152.117C269.665 151.935 269.519 151.766 269.352 151.614L269.19 151.466C268.442 150.781 267.309 150.739 266.511 151.366L253.93 161.255C253.791 161.005 253.63 160.767 253.445 160.543L247.407 153.198C243.134 148.001 236.677 145.101 229.955 145.36L225.953 145.514C223.026 145.627 220.333 147.142 218.72 149.586L209.576 163.427L194.338 156.835C193.36 156.412 192.22 156.758 191.641 157.654L191.508 157.86C191.392 158.042 191.296 158.234 191.221 158.434ZM233.895 116.916C239.925 116.916 243.946 122.724 242.706 129.988C241.495 137.075 235.668 142.76 229.784 142.76C223.754 142.76 219.733 136.952 220.973 129.69C222.182 122.602 228.01 116.916 233.895 116.916ZM233.895 117.802C228.379 117.802 222.98 123.195 221.845 129.838C220.711 136.482 224.268 141.875 229.784 141.875C235.299 141.875 240.698 136.482 241.832 129.838C242.967 123.195 239.41 117.802 233.895 117.802Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Bodypack"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_169",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.548 181.547C247.494 181.547 248.272 182.293 248.311 183.238C248.402 185.437 248.561 189.263 248.655 191.532C248.675 192.012 248.498 192.479 248.165 192.826C247.833 193.173 247.373 193.369 246.892 193.369C245.092 193.369 242.37 193.369 240.622 193.369C239.676 193.369 238.898 192.623 238.859 191.678C238.768 189.479 238.609 185.652 238.515 183.384C238.495 182.904 238.672 182.437 239.004 182.09C239.338 181.743 239.797 181.547 240.278 181.547C242.079 181.547 244.799 181.547 246.548 181.547Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_170",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.548 181.547C247.494 181.547 248.272 182.293 248.311 183.238L248.655 191.532C248.675 192.012 248.498 192.479 248.165 192.826C247.833 193.173 247.373 193.369 246.892 193.369H240.622C239.676 193.369 238.898 192.623 238.859 191.678L238.515 183.384C238.495 182.904 238.672 182.437 239.004 182.09C239.338 181.743 239.797 181.547 240.278 181.547H246.548ZM246.548 182.432H240.278C240.038 182.432 239.81 182.53 239.643 182.703C239.478 182.875 239.39 183.108 239.4 183.347L239.744 191.641C239.764 192.112 240.151 192.483 240.622 192.483H246.892C247.132 192.483 247.361 192.386 247.526 192.213C247.692 192.04 247.779 191.808 247.769 191.568L247.425 183.275C247.406 182.804 247.019 182.432 246.548 182.432Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__aktor"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_166"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_171",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.589 164.211L217.06 167.916L217.032 167.905C215.877 169.566 214.166 170.781 212.188 171.313C209.834 171.947 207.322 171.556 205.272 170.236L192.367 161.928C191.709 161.505 191.246 160.836 191.081 160.071C190.915 159.306 191.06 158.506 191.485 157.848L191.618 157.642C192.195 156.746 193.336 156.4 194.314 156.823L209.552 163.416L218.696 149.574C220.31 147.131 223.003 145.615 225.929 145.502L229.931 145.348C236.654 145.089 243.111 147.989 247.383 153.186L253.422 160.531C253.606 160.755 253.767 160.994 253.906 161.243L266.487 151.354C267.285 150.727 268.419 150.77 269.167 151.454L269.329 151.602C269.922 152.145 270.269 152.905 270.291 153.709C270.313 154.512 270.008 155.291 269.446 155.865L259.129 166.399C257.614 167.945 255.524 168.793 253.359 168.738C252.208 168.709 251.091 168.426 250.081 167.923C249.518 167.792 248.99 167.497 248.572 167.046L243.955 162.063C243.976 162.296 243.99 162.531 243.997 162.768L244.848 190.346L247.215 243.74H239.22L235.084 190.346H230.345L232.232 243.74H223.987L220.975 190.346L219.589 164.211Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_172",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.49 168.605C215.37 169.908 213.876 170.859 212.188 171.313C209.834 171.947 207.322 171.556 205.272 170.236L192.367 161.928C191.709 161.505 191.246 160.836 191.081 160.071C190.978 159.599 190.995 159.113 191.122 158.656C191.234 158.707 191.358 158.734 191.485 158.734C191.786 158.734 192.066 158.581 192.229 158.328C191.932 158.789 191.831 159.348 191.946 159.884C192.062 160.42 192.386 160.887 192.847 161.183L205.752 169.491C207.591 170.675 209.845 171.027 211.958 170.458C213.732 169.98 215.268 168.89 216.304 167.399C216.116 167.67 216.094 168.023 216.247 168.315C216.307 168.43 216.39 168.528 216.49 168.605ZM269.886 152.291C270.136 152.718 270.277 153.205 270.291 153.709C270.313 154.512 270.008 155.291 269.446 155.865L259.129 166.399C257.614 167.945 255.524 168.793 253.359 168.738C252.208 168.709 251.091 168.426 250.081 167.923C249.518 167.792 248.99 167.497 248.572 167.046L243.955 162.063C243.976 162.296 243.99 162.531 243.997 162.768L244.848 190.346L247.215 243.74H239.22L235.084 190.346H230.344L232.232 243.74H223.987L220.975 190.346L219.589 164.211L217.06 167.916L217.032 167.905C216.864 168.146 216.685 168.377 216.495 168.599C216.407 168.525 216.332 168.435 216.276 168.33C216.123 168.04 216.143 167.688 216.328 167.417L218.857 163.711C219.071 163.397 219.462 163.255 219.827 163.358C220.193 163.46 220.453 163.784 220.473 164.164L221.859 190.298L224.824 242.855H231.315L229.459 190.377C229.451 190.137 229.54 189.904 229.707 189.731C229.874 189.558 230.104 189.46 230.344 189.46H235.084C235.546 189.46 235.931 189.816 235.967 190.277L240.04 242.855H246.289L243.963 190.385L243.963 190.373L243.112 162.796C243.105 162.576 243.092 162.357 243.073 162.141C243.04 161.764 243.25 161.407 243.596 161.253C243.942 161.1 244.348 161.183 244.605 161.461L249.222 166.444C249.515 166.761 249.886 166.968 250.282 167.06C250.349 167.076 250.414 167.1 250.476 167.13C251.371 167.576 252.361 167.827 253.382 167.853C255.3 167.901 257.153 167.15 258.496 165.779L268.813 155.245C269.207 154.842 269.421 154.297 269.406 153.733C269.391 153.169 269.147 152.636 268.731 152.256C268.894 152.405 269.107 152.488 269.329 152.488C269.536 152.488 269.731 152.416 269.886 152.291ZM191.485 158.734L191.351 158.487C191.298 158.47 191.247 158.448 191.198 158.422C191.272 158.222 191.368 158.03 191.485 157.848L191.618 157.642C192.195 156.746 193.336 156.4 194.314 156.823L209.552 163.416L218.696 149.574C220.31 147.131 223.003 145.615 225.929 145.502L229.931 145.348C236.654 145.089 243.111 147.989 247.383 153.186L253.422 160.531C253.606 160.755 253.767 160.994 253.906 161.243L266.487 151.354C267.285 150.727 268.419 150.77 269.167 151.454L269.329 151.602C269.495 151.754 269.642 151.923 269.768 152.106C269.663 152.202 269.536 152.272 269.397 152.31L269.329 152.488L268.727 152.252L268.574 152.112L268.569 152.108C268.141 151.716 267.491 151.692 267.035 152.05L254.454 161.94C254.249 162.1 253.986 162.163 253.731 162.112C253.477 162.06 253.258 161.9 253.132 161.674C253.019 161.47 252.887 161.276 252.737 161.094L246.699 153.749C242.602 148.766 236.411 145.985 229.965 146.233L225.963 146.387C223.322 146.489 220.891 147.857 219.435 150.062L210.291 163.904C210.054 164.262 209.595 164.399 209.2 164.229L193.963 157.636C193.382 157.385 192.705 157.591 192.362 158.122L192.358 158.128L192.232 158.324L191.485 158.734Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_167"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_173",
  d: "M229.761 141.862C235.28 141.862 240.674 136.473 241.809 129.826C242.944 123.178 239.39 117.789 233.871 117.789C228.352 117.789 222.958 123.178 221.823 129.826C220.687 136.473 224.241 141.862 229.761 141.862Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_174",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.871 117.789C239.387 117.789 242.944 123.182 241.809 129.826C240.675 136.469 235.276 141.862 229.761 141.862C224.245 141.862 220.688 136.469 221.823 129.826C222.957 123.182 228.356 117.789 233.871 117.789ZM233.871 118.675C228.724 118.675 223.754 123.775 222.695 129.975C221.667 135.999 224.759 140.976 229.76 140.976C234.908 140.976 239.878 135.876 240.936 129.676C241.965 123.652 238.873 118.675 233.871 118.675Z",
  fill: "#8496B9"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Mic inactive"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_175",
  d: "M227.169 155.593C228.034 170.977 243.265 163.501 244.205 182.023",
  stroke: "#8496B9",
  strokeWidth: 0.875863,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_176",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.044 149.945C227.469 149.945 227.819 150.278 227.84 150.702C227.89 151.685 227.978 153.408 228.034 154.524C228.048 154.802 227.948 155.074 227.756 155.276C227.564 155.478 227.297 155.592 227.018 155.592C227.014 155.592 227.011 155.592 227.006 155.592C226.582 155.592 226.232 155.26 226.21 154.836C226.16 153.853 226.073 152.13 226.016 151.014C226.002 150.736 226.103 150.464 226.295 150.262C226.487 150.06 226.753 149.945 227.032 149.945C227.036 149.945 227.04 149.945 227.044 149.945Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_177",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.044 149.06L227.371 149.092L227.679 149.184L227.958 149.33L228.204 149.523L228.409 149.758L228.569 150.03L228.676 150.332L228.725 150.657L228.919 154.479C228.945 155 228.757 155.508 228.398 155.886C228.039 156.265 227.54 156.479 227.018 156.479H227.006L226.68 156.446L226.372 156.354L226.092 156.209L225.847 156.015L225.641 155.78L225.481 155.508L225.374 155.205L225.326 154.881L225.132 151.059C225.105 150.539 225.293 150.03 225.653 149.652C226.012 149.273 226.511 149.06 227.032 149.06H227.044ZM227.044 149.945H227.032C226.753 149.945 226.487 150.06 226.295 150.262C226.103 150.464 226.002 150.736 226.016 151.014L226.21 154.836C226.232 155.26 226.582 155.592 227.006 155.592H227.018C227.297 155.592 227.564 155.478 227.756 155.276C227.948 155.074 228.048 154.802 228.034 154.524L227.84 150.702C227.819 150.278 227.469 149.945 227.044 149.945Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_178",
  d: "M225.977 153.488L228.232 153.373",
  stroke: "#8496B9",
  strokeWidth: 0.90051,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Statyw"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_179",
  d: "M274.6 246.86V294.691",
  stroke: "#8496B9",
  strokeWidth: 1.79723,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_180",
  d: "M261.131 303.326L274.6 293.988L287.766 308.451",
  stroke: "#8496B9",
  strokeWidth: 1.79723,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_181",
  d: "M274.6 293.988L269.331 315.408",
  stroke: "#8496B9",
  strokeWidth: 1.79723,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Kamera"
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_182",
  d: "M274.448 246.948C284.114 246.948 291.95 239.112 291.95 229.445C291.95 219.779 284.114 211.943 274.448 211.943C264.782 211.943 256.946 219.779 256.946 229.445C256.946 239.112 264.782 246.948 274.448 246.948Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group 464"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask3_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 256,
  y: 211,
  width: 36,
  height: 36
}, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip4"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_183",
  d: "M274.448 246.948C284.114 246.948 291.95 239.112 291.95 229.445C291.95 219.779 284.114 211.943 274.448 211.943C264.782 211.943 256.946 219.779 256.946 229.445C256.946 239.112 264.782 246.948 274.448 246.948Z",
  fill: "white"
})))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask3_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_168"
}, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_184",
  d: "M289.671 240.183C290.961 240.183 292.008 235.193 292.008 229.037C292.008 222.882 290.961 217.891 289.671 217.891C288.38 217.891 287.334 222.882 287.334 229.037C287.334 235.193 288.38 240.183 289.671 240.183Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_4"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask4_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 287,
  y: 217,
  width: 6,
  height: 24
}, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip5"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_185",
  d: "M289.671 240.183C290.961 240.183 292.008 235.193 292.008 229.037C292.008 222.882 290.961 217.891 289.671 217.891C288.38 217.891 287.334 222.882 287.334 229.037C287.334 235.193 288.38 240.183 289.671 240.183Z",
  fill: "white"
})))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask4_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_169"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_170"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_186",
  d: "M287.129 232.385C288.833 232.385 290.214 230.887 290.214 229.038C290.214 227.19 288.833 225.691 287.129 225.691C285.425 225.691 284.044 227.19 284.044 229.038C284.044 230.887 285.425 232.385 287.129 232.385Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.697009,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_187",
  d: "M289.671 240.183C290.961 240.183 292.008 235.193 292.008 229.037C292.008 222.882 290.961 217.891 289.671 217.891C288.38 217.891 287.334 222.882 287.334 229.037C287.334 235.193 288.38 240.183 289.671 240.183Z",
  stroke: "#8496B9",
  strokeWidth: 0.868144,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_171"
}, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_188",
  d: "M259.326 240.183C258.036 240.183 256.99 235.193 256.99 229.037C256.99 222.882 258.036 217.891 259.326 217.891C260.617 217.891 261.663 222.882 261.663 229.037C261.663 235.193 260.617 240.183 259.326 240.183Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_5"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask5_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 256,
  y: 217,
  width: 6,
  height: 24
}, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip6"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_189",
  d: "M259.326 240.183C258.036 240.183 256.99 235.193 256.99 229.037C256.99 222.882 258.036 217.891 259.326 217.891C260.617 217.891 261.663 222.882 261.663 229.037C261.663 235.193 260.617 240.183 259.326 240.183Z",
  fill: "white"
})))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask5_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_172"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_173"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_190",
  d: "M261.868 232.385C260.165 232.385 258.784 230.887 258.784 229.038C258.784 227.19 260.165 225.691 261.868 225.691C263.572 225.691 264.953 227.19 264.953 229.038C264.953 230.887 263.572 232.385 261.868 232.385Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.697009,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_191",
  d: "M259.326 240.183C258.036 240.183 256.99 235.193 256.99 229.037C256.99 222.882 258.036 217.891 259.326 217.891C260.617 217.891 261.663 222.882 261.663 229.037C261.663 235.193 260.617 240.183 259.326 240.183Z",
  stroke: "#8496B9",
  strokeWidth: 0.868144,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_174"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_192",
  d: "M274.45 217.538C280.949 217.538 286.218 215.841 286.218 213.747C286.218 211.653 280.949 209.956 274.45 209.956C267.95 209.956 262.681 211.653 262.681 213.747C262.681 215.841 267.95 217.538 274.45 217.538Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.396793,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_175"
}, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_193",
  d: "M268.468 241.523C270.898 241.523 272.868 236.825 272.868 231.03C272.868 225.235 270.898 220.537 268.468 220.537C266.038 220.537 264.068 225.235 264.068 231.03C264.068 236.825 266.038 241.523 268.468 241.523Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask6_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 264,
  y: 220,
  width: 9,
  height: 22
}, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip7"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_194",
  d: "M268.468 241.523C270.898 241.523 272.868 236.825 272.868 231.03C272.868 225.235 270.898 220.537 268.468 220.537C266.038 220.537 264.068 225.235 264.068 231.03C264.068 236.825 266.038 241.523 268.468 241.523Z",
  fill: "white"
})))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask6_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_176"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_177"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_195",
  d: "M268.82 234.182C270.524 234.182 271.905 232.771 271.905 231.031C271.905 229.291 270.524 227.88 268.82 227.88C267.117 227.88 265.736 229.291 265.736 231.031C265.736 232.771 267.117 234.182 268.82 234.182Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.681916,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_196",
  d: "M268.468 241.523C270.898 241.523 272.868 236.825 272.868 231.03C272.868 225.235 270.898 220.537 268.468 220.537C266.038 220.537 264.068 225.235 264.068 231.03C264.068 236.825 266.038 241.523 268.468 241.523Z",
  stroke: "#8496B9",
  strokeWidth: 0.880671,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_178"
}, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_197",
  d: "M280.468 241.523C282.898 241.523 284.868 236.825 284.868 231.03C284.868 225.235 282.898 220.537 280.468 220.537C278.038 220.537 276.069 225.235 276.069 231.03C276.069 236.825 278.038 241.523 280.468 241.523Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Clip path group_7"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask7_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 276,
  y: 220,
  width: 9,
  height: 22
}, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip8"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_198",
  d: "M280.468 241.523C282.898 241.523 284.868 236.825 284.868 231.03C284.868 225.235 282.898 220.537 280.468 220.537C278.038 220.537 276.069 225.235 276.069 231.03C276.069 236.825 278.038 241.523 280.468 241.523Z",
  fill: "white"
})))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask7_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_179"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_180"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_199",
  d: "M280.079 234.182C281.782 234.182 283.163 232.771 283.163 231.031C283.163 229.291 281.782 227.88 280.079 227.88C278.375 227.88 276.994 229.291 276.994 231.031C276.994 232.771 278.375 234.182 280.079 234.182Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.681916,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_200",
  d: "M280.468 241.523C282.898 241.523 284.868 236.825 284.868 231.03C284.868 225.235 282.898 220.537 280.468 220.537C278.038 220.537 276.069 225.235 276.069 231.03C276.069 236.825 278.038 241.523 280.468 241.523Z",
  stroke: "#8496B9",
  strokeWidth: 0.880671,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_201",
  d: "M274.448 246.948C284.114 246.948 291.95 239.112 291.95 229.445C291.95 219.779 284.114 211.943 274.448 211.943C264.782 211.943 256.946 219.779 256.946 229.445C256.946 239.112 264.782 246.948 274.448 246.948Z",
  stroke: "#8496B9",
  strokeWidth: 1.79802,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__CMic inactive"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_202",
  d: "M274.418 211.518L274.418 206.735",
  stroke: "#8496B9",
  strokeWidth: 1.79723,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_181"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_182"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_203",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.56 205.97C273.2 205.97 272.097 204.867 272.097 203.508C272.097 201.085 272.097 197.409 272.097 194.987C272.097 193.627 273.2 192.524 274.56 192.524C274.614 192.524 274.669 192.524 274.724 192.524C276.083 192.524 277.186 193.627 277.186 194.987C277.186 197.409 277.186 201.085 277.186 203.508C277.186 204.867 276.083 205.97 274.724 205.97C274.669 205.97 274.614 205.97 274.56 205.97Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_204",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.56 207.741C272.222 207.741 270.326 205.846 270.326 203.507V194.987C270.326 192.648 272.222 190.753 274.56 190.753H274.724C277.062 190.753 278.957 192.648 278.957 194.987V203.507C278.957 205.846 277.062 207.741 274.724 207.741H274.56ZM274.56 205.97H274.724C276.083 205.97 277.186 204.867 277.186 203.507V194.987C277.186 193.627 276.083 192.524 274.724 192.524H274.56C273.2 192.524 272.097 193.627 272.097 194.987V203.507C272.097 204.867 273.2 205.97 274.56 205.97Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_183"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_205",
  d: "M277.186 201.618H271.713",
  stroke: "#8496B9",
  strokeWidth: 0.90113,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_206",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.172 188.399C162.172 188.399 164.584 175.945 176.057 166.21C187.044 156.889 176.344 151.018 168.088 160.235C156.996 172.62 162.172 188.399 162.172 188.399Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.897126,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Mic inactive_2"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prod_room_svg__mask8_6850_10576",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 152,
  y: 122,
  width: 27,
  height: 64
}, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg___clip9"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_207",
  d: "M162.595 185.557C162.595 185.557 150.64 138.453 152.855 133.884C154.918 129.626 167.445 128.518 172.979 123.822C183.966 114.5 176.884 148.617 168.628 157.835C166.837 159.836 165.441 162.62 164.165 164.967C162.222 168.543 161.537 171.509 161.537 171.509L160.78 174.852L162.595 185.557Z",
  fill: "white"
})))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prod_room_svg__mask8_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_184"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_185"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_208",
  d: "M162.87 152.674L162.87 171.393",
  stroke: "#8496B9",
  strokeWidth: 1.44184,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_186"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_209",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.83 154.704C161.47 154.704 160.367 153.602 160.367 152.242C160.367 149.82 160.367 146.143 160.367 143.721C160.367 142.361 161.47 141.258 162.83 141.258C162.884 141.258 162.939 141.258 162.994 141.258C164.353 141.258 165.456 142.361 165.456 143.721C165.456 146.143 165.456 149.82 165.456 152.242C165.456 153.602 164.353 154.704 162.994 154.704C162.939 154.704 162.884 154.704 162.83 154.704Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_210",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.83 155.59C160.981 155.59 159.482 154.091 159.482 152.242L159.482 143.721C159.482 141.872 160.981 140.373 162.83 140.373L162.994 140.373C164.843 140.373 166.342 141.872 166.342 143.721L166.342 152.242C166.342 154.091 164.843 155.59 162.994 155.59L162.83 155.59ZM162.83 154.705L162.994 154.705C164.353 154.705 165.456 153.602 165.456 152.242L165.456 143.721C165.456 142.361 164.353 141.259 162.994 141.259L162.83 141.259C161.47 141.259 160.367 142.361 160.367 143.721L160.367 152.242C160.367 153.602 161.47 154.705 162.83 154.705Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_211",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.83 154.704C161.47 154.704 160.367 153.602 160.367 152.242L160.367 143.721C160.367 142.361 161.47 141.258 162.83 141.258L162.994 141.258C164.353 141.258 165.456 142.361 165.456 143.721L165.456 152.242C165.456 153.602 164.353 154.704 162.994 154.704L162.83 154.704ZM162.83 154.172L162.994 154.172C164.06 154.172 164.924 153.308 164.924 152.242L164.924 143.721C164.924 142.654 164.06 141.79 162.994 141.79L162.83 141.79C161.763 141.79 160.899 142.654 160.899 143.721L160.899 152.242C160.899 153.308 161.763 154.172 162.83 154.172Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__Group_187"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Vector_212",
  d: "M165.456 150.357L159.983 150.357",
  stroke: "#8496B9",
  strokeWidth: 0.901127,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__label-wms",
  className: "label-wms",
  filter: "url(#prod_room_svg__filter0_d_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__tip"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Polygon 4",
  d: "M248.431 134.239L256.431 129.239L256.431 134.239L256.431 139.239L248.431 134.239Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__text"
}, /*#__PURE__*/React.createElement("rect", {
  x: 256.431,
  y: 119.239,
  width: 180,
  height: 30,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Tooltip",
  d: "M267.992 139.239L265.004 130.779H266.612L268.916 137.715H268.436L270.92 130.779H272.072L274.376 137.715H273.932L276.344 130.779H277.856L274.844 139.239H273.56L271.328 132.735H271.592L269.276 139.239H267.992ZM278.973 139.239V133.179H280.473V139.239H278.973ZM278.889 132.039V130.575H280.557V132.039H278.889ZM282.09 139.239V134.727C282.09 134.471 282.082 134.211 282.066 133.947C282.058 133.683 282.038 133.427 282.006 133.179H283.458L283.626 134.835H283.386C283.466 134.435 283.598 134.103 283.782 133.839C283.974 133.575 284.206 133.379 284.478 133.251C284.75 133.123 285.046 133.059 285.366 133.059C285.51 133.059 285.626 133.067 285.714 133.083C285.802 133.091 285.89 133.111 285.978 133.143L285.966 134.463C285.814 134.399 285.682 134.359 285.57 134.343C285.466 134.327 285.334 134.319 285.174 134.319C284.83 134.319 284.538 134.391 284.298 134.535C284.066 134.679 283.89 134.879 283.77 135.135C283.658 135.391 283.602 135.683 283.602 136.011V139.239H282.09ZM289.648 139.359C288.632 139.359 287.836 139.079 287.26 138.519C286.684 137.959 286.396 137.191 286.396 136.215C286.396 135.583 286.52 135.031 286.768 134.559C287.016 134.087 287.36 133.719 287.8 133.455C288.248 133.191 288.768 133.059 289.36 133.059C289.944 133.059 290.432 133.183 290.824 133.431C291.216 133.679 291.512 134.027 291.712 134.475C291.92 134.923 292.024 135.447 292.024 136.047V136.443H287.608V135.651H290.956L290.752 135.819C290.752 135.259 290.632 134.831 290.392 134.535C290.16 134.239 289.82 134.091 289.372 134.091C288.876 134.091 288.492 134.267 288.22 134.619C287.956 134.971 287.824 135.463 287.824 136.095V136.251C287.824 136.907 287.984 137.399 288.304 137.727C288.632 138.047 289.092 138.207 289.684 138.207C290.028 138.207 290.348 138.163 290.644 138.075C290.948 137.979 291.236 137.827 291.508 137.619L291.952 138.627C291.664 138.859 291.32 139.039 290.92 139.167C290.52 139.295 290.096 139.359 289.648 139.359ZM293.294 139.239V130.407H294.794V139.239H293.294ZM299.351 139.359C298.335 139.359 297.539 139.079 296.963 138.519C296.387 137.959 296.099 137.191 296.099 136.215C296.099 135.583 296.223 135.031 296.471 134.559C296.719 134.087 297.063 133.719 297.503 133.455C297.951 133.191 298.471 133.059 299.063 133.059C299.647 133.059 300.135 133.183 300.527 133.431C300.919 133.679 301.215 134.027 301.415 134.475C301.623 134.923 301.727 135.447 301.727 136.047V136.443H297.311V135.651H300.659L300.455 135.819C300.455 135.259 300.335 134.831 300.095 134.535C299.863 134.239 299.523 134.091 299.075 134.091C298.579 134.091 298.195 134.267 297.923 134.619C297.659 134.971 297.527 135.463 297.527 136.095V136.251C297.527 136.907 297.687 137.399 298.007 137.727C298.335 138.047 298.795 138.207 299.387 138.207C299.731 138.207 300.051 138.163 300.347 138.075C300.651 137.979 300.939 137.827 301.211 137.619L301.655 138.627C301.367 138.859 301.023 139.039 300.623 139.167C300.223 139.295 299.799 139.359 299.351 139.359ZM305.157 139.359C304.637 139.359 304.157 139.299 303.717 139.179C303.285 139.051 302.921 138.875 302.625 138.651L303.045 137.643C303.349 137.851 303.685 138.011 304.053 138.123C304.421 138.235 304.793 138.291 305.169 138.291C305.569 138.291 305.865 138.223 306.057 138.087C306.257 137.951 306.357 137.767 306.357 137.535C306.357 137.351 306.293 137.207 306.165 137.103C306.045 136.991 305.849 136.907 305.577 136.851L304.377 136.623C303.865 136.511 303.473 136.319 303.201 136.047C302.937 135.775 302.805 135.419 302.805 134.979C302.805 134.603 302.905 134.271 303.105 133.983C303.313 133.695 303.605 133.471 303.981 133.311C304.365 133.143 304.813 133.059 305.325 133.059C305.773 133.059 306.193 133.119 306.585 133.239C306.985 133.359 307.321 133.539 307.593 133.779L307.161 134.751C306.913 134.551 306.629 134.395 306.309 134.283C305.989 134.171 305.677 134.115 305.373 134.115C304.957 134.115 304.653 134.191 304.461 134.343C304.269 134.487 304.173 134.675 304.173 134.907C304.173 135.083 304.229 135.231 304.341 135.351C304.461 135.463 304.645 135.547 304.893 135.603L306.093 135.831C306.629 135.935 307.033 136.119 307.305 136.383C307.585 136.639 307.725 136.991 307.725 137.439C307.725 137.839 307.617 138.183 307.401 138.471C307.185 138.759 306.885 138.979 306.501 139.131C306.117 139.283 305.669 139.359 305.157 139.359ZM311.169 139.359C310.649 139.359 310.169 139.299 309.729 139.179C309.297 139.051 308.933 138.875 308.637 138.651L309.057 137.643C309.361 137.851 309.697 138.011 310.065 138.123C310.433 138.235 310.805 138.291 311.181 138.291C311.581 138.291 311.877 138.223 312.069 138.087C312.269 137.951 312.369 137.767 312.369 137.535C312.369 137.351 312.305 137.207 312.177 137.103C312.057 136.991 311.861 136.907 311.589 136.851L310.389 136.623C309.877 136.511 309.485 136.319 309.213 136.047C308.949 135.775 308.817 135.419 308.817 134.979C308.817 134.603 308.917 134.271 309.117 133.983C309.325 133.695 309.617 133.471 309.993 133.311C310.377 133.143 310.825 133.059 311.337 133.059C311.785 133.059 312.205 133.119 312.597 133.239C312.997 133.359 313.333 133.539 313.605 133.779L313.173 134.751C312.925 134.551 312.641 134.395 312.321 134.283C312.001 134.171 311.689 134.115 311.385 134.115C310.969 134.115 310.665 134.191 310.473 134.343C310.281 134.487 310.185 134.675 310.185 134.907C310.185 135.083 310.241 135.231 310.353 135.351C310.473 135.463 310.657 135.547 310.905 135.603L312.105 135.831C312.641 135.935 313.045 136.119 313.317 136.383C313.597 136.639 313.737 136.991 313.737 137.439C313.737 137.839 313.629 138.183 313.413 138.471C313.197 138.759 312.897 138.979 312.513 139.131C312.129 139.283 311.681 139.359 311.169 139.359ZM318.313 139.239V134.691C318.313 134.443 318.305 134.191 318.289 133.935C318.273 133.679 318.249 133.427 318.217 133.179H319.669L319.789 134.379H319.645C319.813 133.963 320.069 133.639 320.413 133.407C320.765 133.175 321.181 133.059 321.661 133.059C322.141 133.059 322.537 133.175 322.849 133.407C323.169 133.631 323.393 133.983 323.521 134.463H323.329C323.497 134.031 323.773 133.691 324.157 133.443C324.541 133.187 324.981 133.059 325.477 133.059C326.157 133.059 326.665 133.259 327.001 133.659C327.337 134.059 327.505 134.683 327.505 135.531V139.239H326.005V135.591C326.005 135.111 325.925 134.767 325.765 134.559C325.605 134.343 325.349 134.235 324.997 134.235C324.581 134.235 324.253 134.383 324.013 134.679C323.773 134.967 323.653 135.359 323.653 135.855V139.239H322.153V135.591C322.153 135.111 322.073 134.767 321.913 134.559C321.753 134.343 321.497 134.235 321.145 134.235C320.729 134.235 320.401 134.383 320.161 134.679C319.929 134.967 319.813 135.359 319.813 135.855V139.239H318.313ZM329.106 139.239V133.179H330.606V139.239H329.106ZM329.022 132.039V130.575H330.69V132.039H329.022ZM335.019 139.359C334.395 139.359 333.847 139.231 333.375 138.975C332.911 138.719 332.551 138.355 332.295 137.883C332.039 137.403 331.911 136.835 331.911 136.179C331.911 135.523 332.039 134.963 332.295 134.499C332.559 134.035 332.923 133.679 333.387 133.431C333.851 133.183 334.395 133.059 335.019 133.059C335.419 133.059 335.807 133.123 336.183 133.251C336.567 133.371 336.879 133.547 337.119 133.779L336.663 134.823C336.447 134.623 336.203 134.475 335.931 134.379C335.667 134.275 335.407 134.223 335.151 134.223C334.615 134.223 334.195 134.391 333.891 134.727C333.595 135.063 333.447 135.551 333.447 136.191C333.447 136.831 333.595 137.323 333.891 137.667C334.195 138.011 334.615 138.183 335.151 138.183C335.399 138.183 335.655 138.135 335.919 138.039C336.191 137.943 336.439 137.795 336.663 137.595L337.119 138.627C336.871 138.859 336.555 139.039 336.171 139.167C335.795 139.295 335.411 139.359 335.019 139.359ZM338.27 139.239V134.727C338.27 134.471 338.262 134.211 338.246 133.947C338.238 133.683 338.218 133.427 338.186 133.179H339.638L339.806 134.835H339.566C339.646 134.435 339.778 134.103 339.962 133.839C340.154 133.575 340.386 133.379 340.658 133.251C340.93 133.123 341.226 133.059 341.546 133.059C341.69 133.059 341.806 133.067 341.894 133.083C341.982 133.091 342.07 133.111 342.158 133.143L342.146 134.463C341.994 134.399 341.862 134.359 341.75 134.343C341.646 134.327 341.514 134.319 341.354 134.319C341.01 134.319 340.718 134.391 340.478 134.535C340.246 134.679 340.07 134.879 339.95 135.135C339.838 135.391 339.782 135.683 339.782 136.011V139.239H338.27ZM345.635 139.359C345.011 139.359 344.471 139.231 344.015 138.975C343.559 138.719 343.203 138.355 342.947 137.883C342.699 137.411 342.575 136.851 342.575 136.203C342.575 135.555 342.699 134.999 342.947 134.535C343.203 134.063 343.559 133.699 344.015 133.443C344.471 133.187 345.011 133.059 345.635 133.059C346.259 133.059 346.799 133.187 347.255 133.443C347.719 133.699 348.075 134.063 348.323 134.535C348.579 134.999 348.707 135.555 348.707 136.203C348.707 136.851 348.579 137.411 348.323 137.883C348.075 138.355 347.719 138.719 347.255 138.975C346.799 139.231 346.259 139.359 345.635 139.359ZM345.635 138.207C346.107 138.207 346.483 138.043 346.763 137.715C347.043 137.379 347.183 136.875 347.183 136.203C347.183 135.531 347.043 135.031 346.763 134.703C346.483 134.375 346.107 134.211 345.635 134.211C345.163 134.211 344.787 134.375 344.507 134.703C344.227 135.031 344.087 135.531 344.087 136.203C344.087 136.875 344.227 137.379 344.507 137.715C344.787 138.043 345.163 138.207 345.635 138.207ZM350.001 141.831V134.691C350.001 134.443 349.993 134.191 349.977 133.935C349.961 133.679 349.937 133.427 349.905 133.179H351.357L351.489 134.451H351.357C351.477 134.027 351.729 133.691 352.113 133.443C352.505 133.187 352.957 133.059 353.469 133.059C354.005 133.059 354.473 133.187 354.873 133.443C355.273 133.691 355.585 134.051 355.809 134.523C356.033 134.987 356.145 135.547 356.145 136.203C356.145 136.859 356.033 137.423 355.809 137.895C355.585 138.367 355.273 138.731 354.873 138.987C354.473 139.235 354.005 139.359 353.469 139.359C352.965 139.359 352.521 139.235 352.137 138.987C351.753 138.739 351.497 138.407 351.369 137.991H351.501V141.831H350.001ZM353.049 138.207C353.529 138.207 353.913 138.043 354.201 137.715C354.489 137.379 354.633 136.875 354.633 136.203C354.633 135.531 354.489 135.031 354.201 134.703C353.913 134.375 353.529 134.211 353.049 134.211C352.577 134.211 352.197 134.375 351.909 134.703C351.621 135.031 351.477 135.531 351.477 136.203C351.477 136.875 351.621 137.379 351.909 137.715C352.197 138.043 352.577 138.207 353.049 138.207ZM357.442 139.239V130.407H358.942V134.391H358.774C358.958 133.959 359.242 133.631 359.626 133.407C360.01 133.175 360.45 133.059 360.946 133.059C361.666 133.059 362.202 133.263 362.554 133.671C362.906 134.071 363.082 134.683 363.082 135.507V139.239H361.582V135.579C361.582 135.107 361.49 134.767 361.306 134.559C361.13 134.343 360.846 134.235 360.454 134.235C359.998 134.235 359.63 134.379 359.35 134.667C359.078 134.947 358.942 135.323 358.942 135.795V139.239H357.442ZM367.409 139.359C366.785 139.359 366.245 139.231 365.789 138.975C365.333 138.719 364.977 138.355 364.721 137.883C364.473 137.411 364.349 136.851 364.349 136.203C364.349 135.555 364.473 134.999 364.721 134.535C364.977 134.063 365.333 133.699 365.789 133.443C366.245 133.187 366.785 133.059 367.409 133.059C368.033 133.059 368.573 133.187 369.029 133.443C369.493 133.699 369.849 134.063 370.097 134.535C370.353 134.999 370.481 135.555 370.481 136.203C370.481 136.851 370.353 137.411 370.097 137.883C369.849 138.355 369.493 138.719 369.029 138.975C368.573 139.231 368.033 139.359 367.409 139.359ZM367.409 138.207C367.881 138.207 368.257 138.043 368.537 137.715C368.817 137.379 368.957 136.875 368.957 136.203C368.957 135.531 368.817 135.031 368.537 134.703C368.257 134.375 367.881 134.211 367.409 134.211C366.937 134.211 366.561 134.375 366.281 134.703C366.001 135.031 365.861 135.531 365.861 136.203C365.861 136.875 366.001 137.379 366.281 137.715C366.561 138.043 366.937 138.207 367.409 138.207ZM371.774 139.239V134.691C371.774 134.443 371.766 134.191 371.75 133.935C371.734 133.679 371.71 133.427 371.678 133.179H373.13L373.25 134.379H373.106C373.298 133.955 373.582 133.631 373.958 133.407C374.334 133.175 374.77 133.059 375.266 133.059C375.978 133.059 376.514 133.259 376.874 133.659C377.234 134.059 377.414 134.683 377.414 135.531V139.239H375.914V135.603C375.914 135.115 375.818 134.767 375.626 134.559C375.442 134.343 375.162 134.235 374.786 134.235C374.322 134.235 373.954 134.379 373.682 134.667C373.41 134.955 373.274 135.339 373.274 135.819V139.239H371.774ZM381.933 139.359C380.917 139.359 380.121 139.079 379.545 138.519C378.969 137.959 378.681 137.191 378.681 136.215C378.681 135.583 378.805 135.031 379.053 134.559C379.301 134.087 379.645 133.719 380.085 133.455C380.533 133.191 381.053 133.059 381.645 133.059C382.229 133.059 382.717 133.183 383.109 133.431C383.501 133.679 383.797 134.027 383.997 134.475C384.205 134.923 384.309 135.447 384.309 136.047V136.443H379.893V135.651H383.241L383.037 135.819C383.037 135.259 382.917 134.831 382.677 134.535C382.445 134.239 382.105 134.091 381.657 134.091C381.161 134.091 380.777 134.267 380.505 134.619C380.241 134.971 380.109 135.463 380.109 136.095V136.251C380.109 136.907 380.269 137.399 380.589 137.727C380.917 138.047 381.377 138.207 381.969 138.207C382.313 138.207 382.633 138.163 382.929 138.075C383.233 137.979 383.521 137.827 383.793 137.619L384.237 138.627C383.949 138.859 383.605 139.039 383.205 139.167C382.805 139.295 382.381 139.359 381.933 139.359ZM391.032 139.359C390.512 139.359 390.032 139.299 389.592 139.179C389.16 139.051 388.796 138.875 388.5 138.651L388.92 137.643C389.224 137.851 389.56 138.011 389.928 138.123C390.296 138.235 390.668 138.291 391.044 138.291C391.444 138.291 391.74 138.223 391.932 138.087C392.132 137.951 392.232 137.767 392.232 137.535C392.232 137.351 392.168 137.207 392.04 137.103C391.92 136.991 391.724 136.907 391.452 136.851L390.252 136.623C389.74 136.511 389.348 136.319 389.076 136.047C388.812 135.775 388.68 135.419 388.68 134.979C388.68 134.603 388.78 134.271 388.98 133.983C389.188 133.695 389.48 133.471 389.856 133.311C390.24 133.143 390.688 133.059 391.2 133.059C391.648 133.059 392.068 133.119 392.46 133.239C392.86 133.359 393.196 133.539 393.468 133.779L393.036 134.751C392.788 134.551 392.504 134.395 392.184 134.283C391.864 134.171 391.552 134.115 391.248 134.115C390.832 134.115 390.528 134.191 390.336 134.343C390.144 134.487 390.048 134.675 390.048 134.907C390.048 135.083 390.104 135.231 390.216 135.351C390.336 135.463 390.52 135.547 390.768 135.603L391.968 135.831C392.504 135.935 392.908 136.119 393.18 136.383C393.46 136.639 393.6 136.991 393.6 137.439C393.6 137.839 393.492 138.183 393.276 138.471C393.06 138.759 392.76 138.979 392.376 139.131C391.992 139.283 391.544 139.359 391.032 139.359ZM394.646 141.963L394.298 140.775C394.674 140.695 394.99 140.603 395.246 140.499C395.502 140.395 395.714 140.259 395.882 140.091C396.05 139.923 396.19 139.707 396.302 139.443L396.602 138.735L396.566 139.323L393.926 133.179H395.522L397.418 137.907H397.07L398.978 133.179H400.49L397.73 139.575C397.546 140.007 397.346 140.363 397.13 140.643C396.914 140.931 396.682 141.159 396.434 141.327C396.186 141.503 395.914 141.639 395.618 141.735C395.322 141.831 394.998 141.907 394.646 141.963ZM403.325 139.359C402.805 139.359 402.325 139.299 401.885 139.179C401.453 139.051 401.089 138.875 400.793 138.651L401.213 137.643C401.517 137.851 401.853 138.011 402.221 138.123C402.589 138.235 402.961 138.291 403.337 138.291C403.737 138.291 404.033 138.223 404.225 138.087C404.425 137.951 404.525 137.767 404.525 137.535C404.525 137.351 404.461 137.207 404.333 137.103C404.213 136.991 404.017 136.907 403.745 136.851L402.545 136.623C402.033 136.511 401.641 136.319 401.369 136.047C401.105 135.775 400.973 135.419 400.973 134.979C400.973 134.603 401.073 134.271 401.273 133.983C401.481 133.695 401.773 133.471 402.149 133.311C402.533 133.143 402.981 133.059 403.493 133.059C403.941 133.059 404.361 133.119 404.753 133.239C405.153 133.359 405.489 133.539 405.761 133.779L405.329 134.751C405.081 134.551 404.797 134.395 404.477 134.283C404.157 134.171 403.845 134.115 403.541 134.115C403.125 134.115 402.821 134.191 402.629 134.343C402.437 134.487 402.341 134.675 402.341 134.907C402.341 135.083 402.397 135.231 402.509 135.351C402.629 135.463 402.813 135.547 403.061 135.603L404.261 135.831C404.797 135.935 405.201 136.119 405.473 136.383C405.753 136.639 405.893 136.991 405.893 137.439C405.893 137.839 405.785 138.183 405.569 138.471C405.353 138.759 405.053 138.979 404.669 139.131C404.285 139.283 403.837 139.359 403.325 139.359ZM409.71 139.359C408.99 139.359 408.446 139.171 408.078 138.795C407.71 138.419 407.526 137.855 407.526 137.103V134.307H406.362V133.179H407.526V131.631L409.026 131.247V133.179H410.646V134.307H409.026V137.007C409.026 137.423 409.106 137.715 409.266 137.883C409.426 138.051 409.646 138.135 409.926 138.135C410.078 138.135 410.206 138.123 410.31 138.099C410.422 138.075 410.53 138.043 410.634 138.003V139.191C410.498 139.247 410.346 139.287 410.178 139.311C410.018 139.343 409.862 139.359 409.71 139.359ZM414.534 139.359C413.518 139.359 412.722 139.079 412.146 138.519C411.57 137.959 411.282 137.191 411.282 136.215C411.282 135.583 411.406 135.031 411.654 134.559C411.902 134.087 412.246 133.719 412.686 133.455C413.134 133.191 413.654 133.059 414.246 133.059C414.83 133.059 415.318 133.183 415.71 133.431C416.102 133.679 416.398 134.027 416.598 134.475C416.806 134.923 416.91 135.447 416.91 136.047V136.443H412.494V135.651H415.842L415.638 135.819C415.638 135.259 415.518 134.831 415.278 134.535C415.046 134.239 414.706 134.091 414.258 134.091C413.762 134.091 413.378 134.267 413.106 134.619C412.842 134.971 412.71 135.463 412.71 136.095V136.251C412.71 136.907 412.87 137.399 413.19 137.727C413.518 138.047 413.978 138.207 414.57 138.207C414.914 138.207 415.234 138.163 415.53 138.075C415.834 137.979 416.122 137.827 416.394 137.619L416.838 138.627C416.55 138.859 416.206 139.039 415.806 139.167C415.406 139.295 414.982 139.359 414.534 139.359ZM418.18 139.239V134.691C418.18 134.443 418.172 134.191 418.156 133.935C418.14 133.679 418.116 133.427 418.084 133.179H419.536L419.656 134.379H419.512C419.68 133.963 419.936 133.639 420.28 133.407C420.632 133.175 421.048 133.059 421.528 133.059C422.008 133.059 422.404 133.175 422.716 133.407C423.036 133.631 423.26 133.983 423.388 134.463H423.196C423.364 134.031 423.64 133.691 424.024 133.443C424.408 133.187 424.848 133.059 425.344 133.059C426.024 133.059 426.532 133.259 426.868 133.659C427.204 134.059 427.372 134.683 427.372 135.531V139.239H425.872V135.591C425.872 135.111 425.792 134.767 425.632 134.559C425.472 134.343 425.216 134.235 424.864 134.235C424.448 134.235 424.12 134.383 423.88 134.679C423.64 134.967 423.52 135.359 423.52 135.855V139.239H422.02V135.591C422.02 135.111 421.94 134.767 421.78 134.559C421.62 134.343 421.364 134.235 421.012 134.235C420.596 134.235 420.268 134.383 420.028 134.679C419.796 134.967 419.68 135.359 419.68 135.855V139.239H418.18Z",
  fill: "#141941"
})))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__label-ms",
  className: "label-ms",
  filter: "url(#prod_room_svg__filter1_d_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__text_2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 242.434,
  y: 325.636,
  width: 124,
  height: 30,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Tooltip_2",
  d: "M251.798 345.636V337.176H253.154L256.262 344.172H255.89L258.998 337.176H260.342V345.636H258.938V339.36H259.37L256.526 345.636H255.602L252.758 339.36H253.202V345.636H251.798ZM264.843 345.756C264.219 345.756 263.679 345.628 263.223 345.372C262.767 345.116 262.411 344.752 262.155 344.28C261.907 343.808 261.783 343.248 261.783 342.6C261.783 341.952 261.907 341.396 262.155 340.932C262.411 340.46 262.767 340.096 263.223 339.84C263.679 339.584 264.219 339.456 264.843 339.456C265.467 339.456 266.007 339.584 266.463 339.84C266.927 340.096 267.283 340.46 267.531 340.932C267.787 341.396 267.915 341.952 267.915 342.6C267.915 343.248 267.787 343.808 267.531 344.28C267.283 344.752 266.927 345.116 266.463 345.372C266.007 345.628 265.467 345.756 264.843 345.756ZM264.843 344.604C265.315 344.604 265.691 344.44 265.971 344.112C266.251 343.776 266.391 343.272 266.391 342.6C266.391 341.928 266.251 341.428 265.971 341.1C265.691 340.772 265.315 340.608 264.843 340.608C264.371 340.608 263.995 340.772 263.715 341.1C263.435 341.428 263.295 341.928 263.295 342.6C263.295 343.272 263.435 343.776 263.715 344.112C263.995 344.44 264.371 344.604 264.843 344.604ZM269.209 345.636V341.088C269.209 340.84 269.201 340.588 269.185 340.332C269.169 340.076 269.145 339.824 269.113 339.576H270.565L270.685 340.776H270.541C270.733 340.352 271.017 340.028 271.393 339.804C271.769 339.572 272.205 339.456 272.701 339.456C273.413 339.456 273.949 339.656 274.309 340.056C274.669 340.456 274.849 341.08 274.849 341.928V345.636H273.349V342C273.349 341.512 273.253 341.164 273.061 340.956C272.877 340.74 272.597 340.632 272.221 340.632C271.757 340.632 271.389 340.776 271.117 341.064C270.845 341.352 270.709 341.736 270.709 342.216V345.636H269.209ZM276.439 345.636V339.576H277.939V345.636H276.439ZM276.355 338.436V336.972H278.023V338.436H276.355ZM282.16 345.756C281.44 345.756 280.896 345.568 280.528 345.192C280.16 344.816 279.976 344.252 279.976 343.5V340.704H278.812V339.576H279.976V338.028L281.476 337.644V339.576H283.096V340.704H281.476V343.404C281.476 343.82 281.556 344.112 281.716 344.28C281.876 344.448 282.096 344.532 282.376 344.532C282.528 344.532 282.656 344.52 282.76 344.496C282.872 344.472 282.98 344.44 283.084 344.4V345.588C282.948 345.644 282.796 345.684 282.628 345.708C282.468 345.74 282.312 345.756 282.16 345.756ZM286.793 345.756C286.169 345.756 285.629 345.628 285.173 345.372C284.717 345.116 284.361 344.752 284.105 344.28C283.857 343.808 283.733 343.248 283.733 342.6C283.733 341.952 283.857 341.396 284.105 340.932C284.361 340.46 284.717 340.096 285.173 339.84C285.629 339.584 286.169 339.456 286.793 339.456C287.417 339.456 287.957 339.584 288.413 339.84C288.877 340.096 289.233 340.46 289.481 340.932C289.737 341.396 289.865 341.952 289.865 342.6C289.865 343.248 289.737 343.808 289.481 344.28C289.233 344.752 288.877 345.116 288.413 345.372C287.957 345.628 287.417 345.756 286.793 345.756ZM286.793 344.604C287.265 344.604 287.641 344.44 287.921 344.112C288.201 343.776 288.341 343.272 288.341 342.6C288.341 341.928 288.201 341.428 287.921 341.1C287.641 340.772 287.265 340.608 286.793 340.608C286.321 340.608 285.945 340.772 285.665 341.1C285.385 341.428 285.245 341.928 285.245 342.6C285.245 343.272 285.385 343.776 285.665 344.112C285.945 344.44 286.321 344.604 286.793 344.604ZM291.146 345.636V341.124C291.146 340.868 291.138 340.608 291.122 340.344C291.114 340.08 291.094 339.824 291.062 339.576H292.514L292.682 341.232H292.442C292.522 340.832 292.654 340.5 292.838 340.236C293.03 339.972 293.262 339.776 293.534 339.648C293.806 339.52 294.102 339.456 294.422 339.456C294.566 339.456 294.682 339.464 294.77 339.48C294.858 339.488 294.946 339.508 295.034 339.54L295.022 340.86C294.87 340.796 294.738 340.756 294.626 340.74C294.522 340.724 294.39 340.716 294.23 340.716C293.886 340.716 293.594 340.788 293.354 340.932C293.122 341.076 292.946 341.276 292.826 341.532C292.714 341.788 292.658 342.08 292.658 342.408V345.636H291.146ZM295.869 345.636V339.576H297.369V345.636H295.869ZM295.785 338.436V336.972H297.453V338.436H295.785ZM298.998 345.636V341.088C298.998 340.84 298.99 340.588 298.974 340.332C298.958 340.076 298.934 339.824 298.902 339.576H300.354L300.474 340.776H300.33C300.522 340.352 300.806 340.028 301.182 339.804C301.558 339.572 301.994 339.456 302.49 339.456C303.202 339.456 303.738 339.656 304.098 340.056C304.458 340.456 304.638 341.08 304.638 341.928V345.636H303.138V342C303.138 341.512 303.042 341.164 302.85 340.956C302.666 340.74 302.386 340.632 302.01 340.632C301.546 340.632 301.178 340.776 300.906 341.064C300.634 341.352 300.498 341.736 300.498 342.216V345.636H298.998ZM309.036 348.324C308.476 348.324 307.968 348.264 307.512 348.144C307.064 348.024 306.664 347.84 306.312 347.592L306.636 346.512C306.868 346.664 307.108 346.788 307.356 346.884C307.604 346.98 307.86 347.052 308.124 347.1C308.388 347.148 308.656 347.172 308.928 347.172C309.488 347.172 309.904 347.032 310.176 346.752C310.456 346.48 310.596 346.088 310.596 345.576V344.124H310.716C310.588 344.54 310.328 344.872 309.936 345.12C309.552 345.368 309.108 345.492 308.604 345.492C308.06 345.492 307.584 345.372 307.176 345.132C306.776 344.884 306.464 344.532 306.24 344.076C306.016 343.62 305.904 343.084 305.904 342.468C305.904 341.852 306.016 341.32 306.24 340.872C306.464 340.416 306.776 340.068 307.176 339.828C307.584 339.58 308.06 339.456 308.604 339.456C309.116 339.456 309.56 339.58 309.936 339.828C310.32 340.068 310.576 340.396 310.704 340.812L310.596 340.74L310.716 339.576H312.168C312.136 339.824 312.112 340.076 312.096 340.332C312.08 340.588 312.072 340.84 312.072 341.088V345.396C312.072 346.348 311.812 347.072 311.292 347.568C310.78 348.072 310.028 348.324 309.036 348.324ZM309.012 344.34C309.492 344.34 309.872 344.18 310.152 343.86C310.44 343.532 310.584 343.068 310.584 342.468C310.584 341.868 310.44 341.408 310.152 341.088C309.872 340.768 309.492 340.608 309.012 340.608C308.524 340.608 308.136 340.768 307.848 341.088C307.56 341.408 307.416 341.868 307.416 342.468C307.416 343.068 307.56 343.532 307.848 343.86C308.136 344.18 308.524 344.34 309.012 344.34ZM320.058 345.756C319.378 345.756 318.75 345.672 318.174 345.504C317.606 345.328 317.118 345.088 316.71 344.784L317.19 343.572C317.462 343.764 317.746 343.928 318.042 344.064C318.338 344.192 318.654 344.292 318.99 344.364C319.326 344.428 319.682 344.46 320.058 344.46C320.69 344.46 321.146 344.356 321.426 344.148C321.706 343.94 321.846 343.668 321.846 343.332C321.846 343.036 321.75 342.812 321.558 342.66C321.366 342.5 321.022 342.368 320.526 342.264L319.17 341.988C318.394 341.828 317.814 341.56 317.43 341.184C317.046 340.808 316.854 340.304 316.854 339.672C316.854 339.144 316.994 338.684 317.274 338.292C317.554 337.9 317.946 337.596 318.45 337.38C318.954 337.164 319.542 337.056 320.214 337.056C320.814 337.056 321.37 337.144 321.882 337.32C322.394 337.488 322.822 337.732 323.166 338.052L322.686 339.204C322.342 338.916 321.966 338.704 321.558 338.568C321.15 338.424 320.694 338.352 320.19 338.352C319.622 338.352 319.178 338.464 318.858 338.688C318.546 338.904 318.39 339.204 318.39 339.588C318.39 339.884 318.486 340.12 318.678 340.296C318.878 340.472 319.214 340.608 319.686 340.704L321.03 340.968C321.83 341.128 322.422 341.392 322.806 341.76C323.19 342.12 323.382 342.608 323.382 343.224C323.382 343.728 323.246 344.172 322.974 344.556C322.702 344.932 322.318 345.228 321.822 345.444C321.326 345.652 320.738 345.756 320.058 345.756ZM324.507 348.36L324.159 347.172C324.535 347.092 324.851 347 325.107 346.896C325.363 346.792 325.575 346.656 325.743 346.488C325.911 346.32 326.051 346.104 326.163 345.84L326.463 345.132L326.427 345.72L323.787 339.576H325.383L327.279 344.304H326.931L328.839 339.576H330.351L327.591 345.972C327.407 346.404 327.207 346.76 326.991 347.04C326.775 347.328 326.543 347.556 326.295 347.724C326.047 347.9 325.775 348.036 325.479 348.132C325.183 348.228 324.859 348.304 324.507 348.36ZM333.185 345.756C332.665 345.756 332.185 345.696 331.745 345.576C331.313 345.448 330.949 345.272 330.653 345.048L331.073 344.04C331.377 344.248 331.713 344.408 332.081 344.52C332.449 344.632 332.821 344.688 333.197 344.688C333.597 344.688 333.893 344.62 334.085 344.484C334.285 344.348 334.385 344.164 334.385 343.932C334.385 343.748 334.321 343.604 334.193 343.5C334.073 343.388 333.877 343.304 333.605 343.248L332.405 343.02C331.893 342.908 331.501 342.716 331.229 342.444C330.965 342.172 330.833 341.816 330.833 341.376C330.833 341 330.933 340.668 331.133 340.38C331.341 340.092 331.633 339.868 332.009 339.708C332.393 339.54 332.841 339.456 333.353 339.456C333.801 339.456 334.221 339.516 334.613 339.636C335.013 339.756 335.349 339.936 335.621 340.176L335.189 341.148C334.941 340.948 334.657 340.792 334.337 340.68C334.017 340.568 333.705 340.512 333.401 340.512C332.985 340.512 332.681 340.588 332.489 340.74C332.297 340.884 332.201 341.072 332.201 341.304C332.201 341.48 332.257 341.628 332.369 341.748C332.489 341.86 332.673 341.944 332.921 342L334.121 342.228C334.657 342.332 335.061 342.516 335.333 342.78C335.613 343.036 335.753 343.388 335.753 343.836C335.753 344.236 335.645 344.58 335.429 344.868C335.213 345.156 334.913 345.376 334.529 345.528C334.145 345.68 333.697 345.756 333.185 345.756ZM339.57 345.756C338.85 345.756 338.306 345.568 337.938 345.192C337.57 344.816 337.386 344.252 337.386 343.5V340.704H336.222V339.576H337.386V338.028L338.886 337.644V339.576H340.506V340.704H338.886V343.404C338.886 343.82 338.966 344.112 339.126 344.28C339.286 344.448 339.506 344.532 339.786 344.532C339.938 344.532 340.066 344.52 340.17 344.496C340.282 344.472 340.39 344.44 340.494 344.4V345.588C340.358 345.644 340.206 345.684 340.038 345.708C339.878 345.74 339.722 345.756 339.57 345.756ZM344.395 345.756C343.379 345.756 342.583 345.476 342.007 344.916C341.431 344.356 341.143 343.588 341.143 342.612C341.143 341.98 341.267 341.428 341.515 340.956C341.763 340.484 342.107 340.116 342.547 339.852C342.995 339.588 343.515 339.456 344.107 339.456C344.691 339.456 345.179 339.58 345.571 339.828C345.963 340.076 346.259 340.424 346.459 340.872C346.667 341.32 346.771 341.844 346.771 342.444V342.84H342.355V342.048H345.703L345.499 342.216C345.499 341.656 345.379 341.228 345.139 340.932C344.907 340.636 344.567 340.488 344.119 340.488C343.623 340.488 343.239 340.664 342.967 341.016C342.703 341.368 342.571 341.86 342.571 342.492V342.648C342.571 343.304 342.731 343.796 343.051 344.124C343.379 344.444 343.839 344.604 344.431 344.604C344.775 344.604 345.095 344.56 345.391 344.472C345.695 344.376 345.983 344.224 346.255 344.016L346.699 345.024C346.411 345.256 346.067 345.436 345.667 345.564C345.267 345.692 344.843 345.756 344.395 345.756ZM348.041 345.636V341.088C348.041 340.84 348.033 340.588 348.017 340.332C348.001 340.076 347.977 339.824 347.945 339.576H349.397L349.517 340.776H349.373C349.541 340.36 349.797 340.036 350.141 339.804C350.493 339.572 350.909 339.456 351.389 339.456C351.869 339.456 352.265 339.572 352.577 339.804C352.897 340.028 353.121 340.38 353.249 340.86H353.057C353.225 340.428 353.501 340.088 353.885 339.84C354.269 339.584 354.709 339.456 355.205 339.456C355.885 339.456 356.393 339.656 356.729 340.056C357.065 340.456 357.233 341.08 357.233 341.928V345.636H355.733V341.988C355.733 341.508 355.653 341.164 355.493 340.956C355.333 340.74 355.077 340.632 354.725 340.632C354.309 340.632 353.981 340.78 353.741 341.076C353.501 341.364 353.381 341.756 353.381 342.252V345.636H351.881V341.988C351.881 341.508 351.801 341.164 351.641 340.956C351.481 340.74 351.225 340.632 350.873 340.632C350.457 340.632 350.129 340.78 349.889 341.076C349.657 341.364 349.541 341.756 349.541 342.252V345.636H348.041Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__tip_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Polygon 4_2",
  d: "M374.434 340.636L366.434 345.636L366.434 340.636L366.434 335.636L374.434 340.636Z",
  fill: "white"
})))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__label-am",
  className: "label-am",
  filter: "url(#prod_room_svg__filter2_d_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__tip_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Polygon 4_3",
  d: "M284.357 194.486L292.357 189.486L292.357 194.486L292.357 199.486L284.357 194.486Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__text_3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 292.357,
  y: 179.486,
  width: 147,
  height: 30,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Tooltip_3",
  d: "M300.812 199.486L304.64 191.026H305.936L309.812 199.486H308.24L307.208 197.11L307.832 197.53H302.756L303.404 197.11L302.372 199.486H300.812ZM305.276 192.682L303.584 196.69L303.272 196.318H307.304L307.052 196.69L305.324 192.682H305.276ZM310.628 199.486V194.938C310.628 194.69 310.62 194.438 310.604 194.182C310.588 193.926 310.564 193.674 310.532 193.426H311.984L312.104 194.626H311.96C312.128 194.21 312.384 193.886 312.728 193.654C313.08 193.422 313.496 193.306 313.976 193.306C314.456 193.306 314.852 193.422 315.164 193.654C315.484 193.878 315.708 194.23 315.836 194.71H315.644C315.812 194.278 316.088 193.938 316.472 193.69C316.856 193.434 317.296 193.306 317.792 193.306C318.472 193.306 318.98 193.506 319.316 193.906C319.652 194.306 319.82 194.93 319.82 195.778V199.486H318.32V195.838C318.32 195.358 318.24 195.014 318.08 194.806C317.92 194.59 317.664 194.482 317.312 194.482C316.896 194.482 316.568 194.63 316.328 194.926C316.088 195.214 315.968 195.606 315.968 196.102V199.486H314.468V195.838C314.468 195.358 314.388 195.014 314.228 194.806C314.068 194.59 313.812 194.482 313.46 194.482C313.044 194.482 312.716 194.63 312.476 194.926C312.244 195.214 312.128 195.606 312.128 196.102V199.486H310.628ZM324.889 199.606C324.377 199.606 323.929 199.482 323.545 199.234C323.161 198.978 322.905 198.634 322.777 198.202H322.909V199.486H321.421V190.654H322.921V194.662H322.777C322.913 194.246 323.173 193.918 323.557 193.678C323.941 193.43 324.385 193.306 324.889 193.306C325.425 193.306 325.893 193.434 326.293 193.69C326.693 193.946 327.005 194.31 327.229 194.782C327.453 195.246 327.565 195.806 327.565 196.462C327.565 197.118 327.453 197.682 327.229 198.154C327.005 198.618 326.689 198.978 326.281 199.234C325.881 199.482 325.417 199.606 324.889 199.606ZM324.469 198.454C324.941 198.454 325.321 198.29 325.609 197.962C325.905 197.634 326.053 197.134 326.053 196.462C326.053 195.79 325.905 195.29 325.609 194.962C325.321 194.626 324.941 194.458 324.469 194.458C323.997 194.458 323.617 194.622 323.329 194.95C323.041 195.278 322.897 195.778 322.897 196.45C322.897 197.122 323.041 197.626 323.329 197.962C323.617 198.29 323.997 198.454 324.469 198.454ZM328.863 199.486V193.426H330.363V199.486H328.863ZM328.779 192.286V190.822H330.447V192.286H328.779ZM334.151 199.606C333.631 199.606 333.151 199.546 332.711 199.426C332.279 199.298 331.915 199.122 331.619 198.898L332.039 197.89C332.343 198.098 332.679 198.258 333.047 198.37C333.415 198.482 333.787 198.538 334.163 198.538C334.563 198.538 334.859 198.47 335.051 198.334C335.251 198.198 335.351 198.014 335.351 197.782C335.351 197.598 335.287 197.454 335.159 197.35C335.039 197.238 334.843 197.154 334.571 197.098L333.371 196.87C332.859 196.758 332.467 196.566 332.195 196.294C331.931 196.022 331.799 195.666 331.799 195.226C331.799 194.85 331.899 194.518 332.099 194.23C332.307 193.942 332.599 193.718 332.975 193.558C333.359 193.39 333.807 193.306 334.319 193.306C334.767 193.306 335.187 193.366 335.579 193.486C335.979 193.606 336.315 193.786 336.587 194.026L336.155 194.998C335.907 194.798 335.623 194.642 335.303 194.53C334.983 194.418 334.671 194.362 334.367 194.362C333.951 194.362 333.647 194.438 333.455 194.59C333.263 194.734 333.167 194.922 333.167 195.154C333.167 195.33 333.223 195.478 333.335 195.598C333.455 195.71 333.639 195.794 333.887 195.85L335.087 196.078C335.623 196.182 336.027 196.366 336.299 196.63C336.579 196.886 336.719 197.238 336.719 197.686C336.719 198.086 336.611 198.43 336.395 198.718C336.179 199.006 335.879 199.226 335.495 199.378C335.111 199.53 334.663 199.606 334.151 199.606ZM340.739 199.606C340.115 199.606 339.575 199.478 339.119 199.222C338.663 198.966 338.307 198.602 338.051 198.13C337.803 197.658 337.679 197.098 337.679 196.45C337.679 195.802 337.803 195.246 338.051 194.782C338.307 194.31 338.663 193.946 339.119 193.69C339.575 193.434 340.115 193.306 340.739 193.306C341.363 193.306 341.903 193.434 342.359 193.69C342.823 193.946 343.179 194.31 343.427 194.782C343.683 195.246 343.811 195.802 343.811 196.45C343.811 197.098 343.683 197.658 343.427 198.13C343.179 198.602 342.823 198.966 342.359 199.222C341.903 199.478 341.363 199.606 340.739 199.606ZM340.739 198.454C341.211 198.454 341.587 198.29 341.867 197.962C342.147 197.626 342.287 197.122 342.287 196.45C342.287 195.778 342.147 195.278 341.867 194.95C341.587 194.622 341.211 194.458 340.739 194.458C340.267 194.458 339.891 194.622 339.611 194.95C339.331 195.278 339.191 195.778 339.191 196.45C339.191 197.122 339.331 197.626 339.611 197.962C339.891 198.29 340.267 198.454 340.739 198.454ZM345.105 199.486V194.938C345.105 194.69 345.097 194.438 345.081 194.182C345.065 193.926 345.041 193.674 345.009 193.426H346.461L346.581 194.626H346.437C346.629 194.202 346.913 193.878 347.289 193.654C347.665 193.422 348.101 193.306 348.597 193.306C349.309 193.306 349.845 193.506 350.205 193.906C350.565 194.306 350.745 194.93 350.745 195.778V199.486H349.245V195.85C349.245 195.362 349.149 195.014 348.957 194.806C348.773 194.59 348.493 194.482 348.117 194.482C347.653 194.482 347.285 194.626 347.013 194.914C346.741 195.202 346.605 195.586 346.605 196.066V199.486H345.105ZM352.335 199.486V193.426H353.835V199.486H352.335ZM352.251 192.286V190.822H353.919V192.286H352.251ZM358.248 199.606C357.624 199.606 357.076 199.478 356.604 199.222C356.14 198.966 355.78 198.602 355.524 198.13C355.268 197.65 355.14 197.082 355.14 196.426C355.14 195.77 355.268 195.21 355.524 194.746C355.788 194.282 356.152 193.926 356.616 193.678C357.08 193.43 357.624 193.306 358.248 193.306C358.648 193.306 359.036 193.37 359.412 193.498C359.796 193.618 360.108 193.794 360.348 194.026L359.892 195.07C359.676 194.87 359.432 194.722 359.16 194.626C358.896 194.522 358.636 194.47 358.38 194.47C357.844 194.47 357.424 194.638 357.12 194.974C356.824 195.31 356.676 195.798 356.676 196.438C356.676 197.078 356.824 197.57 357.12 197.914C357.424 198.258 357.844 198.43 358.38 198.43C358.628 198.43 358.884 198.382 359.148 198.286C359.42 198.19 359.668 198.042 359.892 197.842L360.348 198.874C360.1 199.106 359.784 199.286 359.4 199.414C359.024 199.542 358.64 199.606 358.248 199.606ZM364.936 199.486V191.026H366.292L369.4 198.022H369.028L372.136 191.026H373.48V199.486H372.076V193.21H372.508L369.664 199.486H368.74L365.896 193.21H366.34V199.486H364.936ZM375.245 199.486V193.426H376.745V199.486H375.245ZM375.161 192.286V190.822H376.829V192.286H375.161ZM381.158 199.606C380.534 199.606 379.986 199.478 379.514 199.222C379.05 198.966 378.69 198.602 378.434 198.13C378.178 197.65 378.05 197.082 378.05 196.426C378.05 195.77 378.178 195.21 378.434 194.746C378.698 194.282 379.062 193.926 379.526 193.678C379.99 193.43 380.534 193.306 381.158 193.306C381.558 193.306 381.946 193.37 382.322 193.498C382.706 193.618 383.018 193.794 383.258 194.026L382.802 195.07C382.586 194.87 382.342 194.722 382.07 194.626C381.806 194.522 381.546 194.47 381.29 194.47C380.754 194.47 380.334 194.638 380.03 194.974C379.734 195.31 379.586 195.798 379.586 196.438C379.586 197.078 379.734 197.57 380.03 197.914C380.334 198.258 380.754 198.43 381.29 198.43C381.538 198.43 381.794 198.382 382.058 198.286C382.33 198.19 382.578 198.042 382.802 197.842L383.258 198.874C383.01 199.106 382.694 199.286 382.31 199.414C381.934 199.542 381.55 199.606 381.158 199.606ZM384.409 199.486V194.974C384.409 194.718 384.401 194.458 384.385 194.194C384.377 193.93 384.357 193.674 384.325 193.426H385.777L385.945 195.082H385.705C385.785 194.682 385.917 194.35 386.101 194.086C386.293 193.822 386.525 193.626 386.797 193.498C387.069 193.37 387.365 193.306 387.685 193.306C387.829 193.306 387.945 193.314 388.033 193.33C388.121 193.338 388.209 193.358 388.297 193.39L388.285 194.71C388.133 194.646 388.001 194.606 387.889 194.59C387.785 194.574 387.653 194.566 387.493 194.566C387.149 194.566 386.857 194.638 386.617 194.782C386.385 194.926 386.209 195.126 386.089 195.382C385.977 195.638 385.921 195.93 385.921 196.258V199.486H384.409ZM391.774 199.606C391.15 199.606 390.61 199.478 390.154 199.222C389.698 198.966 389.342 198.602 389.086 198.13C388.838 197.658 388.714 197.098 388.714 196.45C388.714 195.802 388.838 195.246 389.086 194.782C389.342 194.31 389.698 193.946 390.154 193.69C390.61 193.434 391.15 193.306 391.774 193.306C392.398 193.306 392.938 193.434 393.394 193.69C393.858 193.946 394.214 194.31 394.462 194.782C394.718 195.246 394.846 195.802 394.846 196.45C394.846 197.098 394.718 197.658 394.462 198.13C394.214 198.602 393.858 198.966 393.394 199.222C392.938 199.478 392.398 199.606 391.774 199.606ZM391.774 198.454C392.246 198.454 392.622 198.29 392.902 197.962C393.182 197.626 393.322 197.122 393.322 196.45C393.322 195.778 393.182 195.278 392.902 194.95C392.622 194.622 392.246 194.458 391.774 194.458C391.302 194.458 390.926 194.622 390.646 194.95C390.366 195.278 390.226 195.778 390.226 196.45C390.226 197.122 390.366 197.626 390.646 197.962C390.926 198.29 391.302 198.454 391.774 198.454ZM396.14 202.078V194.938C396.14 194.69 396.132 194.438 396.116 194.182C396.1 193.926 396.076 193.674 396.044 193.426H397.496L397.628 194.698H397.496C397.616 194.274 397.868 193.938 398.252 193.69C398.644 193.434 399.096 193.306 399.608 193.306C400.144 193.306 400.612 193.434 401.012 193.69C401.412 193.938 401.724 194.298 401.948 194.77C402.172 195.234 402.284 195.794 402.284 196.45C402.284 197.106 402.172 197.67 401.948 198.142C401.724 198.614 401.412 198.978 401.012 199.234C400.612 199.482 400.144 199.606 399.608 199.606C399.104 199.606 398.66 199.482 398.276 199.234C397.892 198.986 397.636 198.654 397.508 198.238H397.64V202.078H396.14ZM399.188 198.454C399.668 198.454 400.052 198.29 400.34 197.962C400.628 197.626 400.772 197.122 400.772 196.45C400.772 195.778 400.628 195.278 400.34 194.95C400.052 194.622 399.668 194.458 399.188 194.458C398.716 194.458 398.336 194.622 398.048 194.95C397.76 195.278 397.616 195.778 397.616 196.45C397.616 197.122 397.76 197.626 398.048 197.962C398.336 198.29 398.716 198.454 399.188 198.454ZM403.581 199.486V190.654H405.081V194.638H404.913C405.097 194.206 405.381 193.878 405.765 193.654C406.149 193.422 406.589 193.306 407.085 193.306C407.805 193.306 408.341 193.51 408.693 193.918C409.045 194.318 409.221 194.93 409.221 195.754V199.486H407.721V195.826C407.721 195.354 407.629 195.014 407.445 194.806C407.269 194.59 406.985 194.482 406.593 194.482C406.137 194.482 405.769 194.626 405.489 194.914C405.217 195.194 405.081 195.57 405.081 196.042V199.486H403.581ZM413.548 199.606C412.924 199.606 412.384 199.478 411.928 199.222C411.472 198.966 411.116 198.602 410.86 198.13C410.612 197.658 410.488 197.098 410.488 196.45C410.488 195.802 410.612 195.246 410.86 194.782C411.116 194.31 411.472 193.946 411.928 193.69C412.384 193.434 412.924 193.306 413.548 193.306C414.172 193.306 414.712 193.434 415.168 193.69C415.632 193.946 415.988 194.31 416.236 194.782C416.492 195.246 416.62 195.802 416.62 196.45C416.62 197.098 416.492 197.658 416.236 198.13C415.988 198.602 415.632 198.966 415.168 199.222C414.712 199.478 414.172 199.606 413.548 199.606ZM413.548 198.454C414.02 198.454 414.396 198.29 414.676 197.962C414.956 197.626 415.096 197.122 415.096 196.45C415.096 195.778 414.956 195.278 414.676 194.95C414.396 194.622 414.02 194.458 413.548 194.458C413.076 194.458 412.7 194.622 412.42 194.95C412.14 195.278 412 195.778 412 196.45C412 197.122 412.14 197.626 412.42 197.962C412.7 198.29 413.076 198.454 413.548 198.454ZM417.913 199.486V194.938C417.913 194.69 417.905 194.438 417.889 194.182C417.873 193.926 417.849 193.674 417.817 193.426H419.269L419.389 194.626H419.245C419.437 194.202 419.721 193.878 420.097 193.654C420.473 193.422 420.909 193.306 421.405 193.306C422.117 193.306 422.653 193.506 423.013 193.906C423.373 194.306 423.553 194.93 423.553 195.778V199.486H422.053V195.85C422.053 195.362 421.957 195.014 421.765 194.806C421.581 194.59 421.301 194.482 420.925 194.482C420.461 194.482 420.093 194.626 419.821 194.914C419.549 195.202 419.413 195.586 419.413 196.066V199.486H417.913ZM428.072 199.606C427.056 199.606 426.26 199.326 425.684 198.766C425.108 198.206 424.82 197.438 424.82 196.462C424.82 195.83 424.944 195.278 425.192 194.806C425.44 194.334 425.784 193.966 426.224 193.702C426.672 193.438 427.192 193.306 427.784 193.306C428.368 193.306 428.856 193.43 429.248 193.678C429.64 193.926 429.936 194.274 430.136 194.722C430.344 195.17 430.448 195.694 430.448 196.294V196.69H426.032V195.898H429.38L429.176 196.066C429.176 195.506 429.056 195.078 428.816 194.782C428.584 194.486 428.244 194.338 427.796 194.338C427.3 194.338 426.916 194.514 426.644 194.866C426.38 195.218 426.248 195.71 426.248 196.342V196.498C426.248 197.154 426.408 197.646 426.728 197.974C427.056 198.294 427.516 198.454 428.108 198.454C428.452 198.454 428.772 198.41 429.068 198.322C429.372 198.226 429.66 198.074 429.932 197.866L430.376 198.874C430.088 199.106 429.744 199.286 429.344 199.414C428.944 199.542 428.52 199.606 428.072 199.606Z",
  fill: "#141941"
})))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__label-ar",
  className: "label-ar",
  filter: "url(#prod_room_svg__filter3_d_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__text_4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 449,
  y: 283,
  width: 105,
  height: 30,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Tooltip_4",
  d: "M457.332 303L461.16 294.54H462.456L466.332 303H464.76L463.728 300.624L464.352 301.044H459.276L459.924 300.624L458.892 303H457.332ZM461.796 296.196L460.104 300.204L459.792 299.832H463.824L463.572 300.204L461.844 296.196H461.796ZM469.332 303.12C468.588 303.12 468.032 302.916 467.664 302.508C467.296 302.1 467.112 301.476 467.112 300.636V296.94H468.612V300.624C468.612 301.072 468.704 301.404 468.888 301.62C469.072 301.828 469.352 301.932 469.728 301.932C470.152 301.932 470.496 301.788 470.76 301.5C471.032 301.212 471.168 300.832 471.168 300.36V296.94H472.668V303H471.204V301.764H471.372C471.196 302.196 470.928 302.532 470.568 302.772C470.216 303.004 469.804 303.12 469.332 303.12ZM476.648 303.12C476.12 303.12 475.652 302.996 475.244 302.748C474.844 302.492 474.532 302.128 474.308 301.656C474.084 301.184 473.972 300.62 473.972 299.964C473.972 299.308 474.084 298.748 474.308 298.284C474.532 297.812 474.844 297.452 475.244 297.204C475.652 296.948 476.12 296.82 476.648 296.82C477.152 296.82 477.596 296.944 477.98 297.192C478.372 297.432 478.632 297.76 478.76 298.176H478.604V294.168H480.104V303H478.628V301.716H478.772C478.644 302.148 478.384 302.492 477.992 302.748C477.608 302.996 477.16 303.12 476.648 303.12ZM477.068 301.968C477.54 301.968 477.92 301.804 478.208 301.476C478.496 301.14 478.64 300.636 478.64 299.964C478.64 299.292 478.496 298.792 478.208 298.464C477.92 298.136 477.54 297.972 477.068 297.972C476.596 297.972 476.212 298.136 475.916 298.464C475.628 298.792 475.484 299.292 475.484 299.964C475.484 300.636 475.628 301.14 475.916 301.476C476.212 301.804 476.596 301.968 477.068 301.968ZM481.738 303V296.94H483.238V303H481.738ZM481.654 295.8V294.336H483.322V295.8H481.654ZM487.603 303.12C486.979 303.12 486.439 302.992 485.983 302.736C485.527 302.48 485.171 302.116 484.915 301.644C484.667 301.172 484.543 300.612 484.543 299.964C484.543 299.316 484.667 298.76 484.915 298.296C485.171 297.824 485.527 297.46 485.983 297.204C486.439 296.948 486.979 296.82 487.603 296.82C488.227 296.82 488.767 296.948 489.223 297.204C489.687 297.46 490.043 297.824 490.291 298.296C490.547 298.76 490.675 299.316 490.675 299.964C490.675 300.612 490.547 301.172 490.291 301.644C490.043 302.116 489.687 302.48 489.223 302.736C488.767 302.992 488.227 303.12 487.603 303.12ZM487.603 301.968C488.075 301.968 488.451 301.804 488.731 301.476C489.011 301.14 489.151 300.636 489.151 299.964C489.151 299.292 489.011 298.792 488.731 298.464C488.451 298.136 488.075 297.972 487.603 297.972C487.131 297.972 486.755 298.136 486.475 298.464C486.195 298.792 486.055 299.292 486.055 299.964C486.055 300.636 486.195 301.14 486.475 301.476C486.755 301.804 487.131 301.968 487.603 301.968ZM495.381 303V294.54H499.077C500.005 294.54 500.721 294.76 501.225 295.2C501.737 295.64 501.993 296.252 501.993 297.036C501.993 297.556 501.877 298 501.645 298.368C501.421 298.736 501.097 299.02 500.673 299.22C500.249 299.412 499.749 299.508 499.173 299.508L499.341 299.28H499.749C500.085 299.28 500.385 299.368 500.649 299.544C500.913 299.72 501.129 299.988 501.297 300.348L502.533 303H500.829L499.581 300.252C499.469 299.972 499.297 299.788 499.065 299.7C498.841 299.612 498.569 299.568 498.249 299.568H496.929V303H495.381ZM496.929 298.428H498.825C499.369 298.428 499.781 298.316 500.061 298.092C500.349 297.86 500.493 297.524 500.493 297.084C500.493 296.644 500.349 296.312 500.061 296.088C499.781 295.864 499.369 295.752 498.825 295.752H496.929V298.428ZM506.463 303.12C505.447 303.12 504.651 302.84 504.075 302.28C503.499 301.72 503.211 300.952 503.211 299.976C503.211 299.344 503.335 298.792 503.583 298.32C503.831 297.848 504.175 297.48 504.615 297.216C505.063 296.952 505.583 296.82 506.175 296.82C506.759 296.82 507.247 296.944 507.639 297.192C508.031 297.44 508.327 297.788 508.527 298.236C508.735 298.684 508.839 299.208 508.839 299.808V300.204H504.423V299.412H507.771L507.567 299.58C507.567 299.02 507.447 298.592 507.207 298.296C506.975 298 506.635 297.852 506.187 297.852C505.691 297.852 505.307 298.028 505.035 298.38C504.771 298.732 504.639 299.224 504.639 299.856V300.012C504.639 300.668 504.799 301.16 505.119 301.488C505.447 301.808 505.907 301.968 506.499 301.968C506.843 301.968 507.163 301.924 507.459 301.836C507.763 301.74 508.051 301.588 508.323 301.38L508.767 302.388C508.479 302.62 508.135 302.8 507.735 302.928C507.335 303.056 506.911 303.12 506.463 303.12ZM512.893 303.12C512.269 303.12 511.721 302.992 511.249 302.736C510.785 302.48 510.425 302.116 510.169 301.644C509.913 301.164 509.785 300.596 509.785 299.94C509.785 299.284 509.913 298.724 510.169 298.26C510.433 297.796 510.797 297.44 511.261 297.192C511.725 296.944 512.269 296.82 512.893 296.82C513.293 296.82 513.681 296.884 514.057 297.012C514.441 297.132 514.753 297.308 514.993 297.54L514.537 298.584C514.321 298.384 514.077 298.236 513.805 298.14C513.541 298.036 513.281 297.984 513.025 297.984C512.489 297.984 512.069 298.152 511.765 298.488C511.469 298.824 511.321 299.312 511.321 299.952C511.321 300.592 511.469 301.084 511.765 301.428C512.069 301.772 512.489 301.944 513.025 301.944C513.273 301.944 513.529 301.896 513.793 301.8C514.065 301.704 514.313 301.556 514.537 301.356L514.993 302.388C514.745 302.62 514.429 302.8 514.045 302.928C513.669 303.056 513.285 303.12 512.893 303.12ZM518.775 303.12C518.151 303.12 517.611 302.992 517.155 302.736C516.699 302.48 516.343 302.116 516.087 301.644C515.839 301.172 515.715 300.612 515.715 299.964C515.715 299.316 515.839 298.76 516.087 298.296C516.343 297.824 516.699 297.46 517.155 297.204C517.611 296.948 518.151 296.82 518.775 296.82C519.399 296.82 519.939 296.948 520.395 297.204C520.859 297.46 521.215 297.824 521.463 298.296C521.719 298.76 521.847 299.316 521.847 299.964C521.847 300.612 521.719 301.172 521.463 301.644C521.215 302.116 520.859 302.48 520.395 302.736C519.939 302.992 519.399 303.12 518.775 303.12ZM518.775 301.968C519.247 301.968 519.623 301.804 519.903 301.476C520.183 301.14 520.323 300.636 520.323 299.964C520.323 299.292 520.183 298.792 519.903 298.464C519.623 298.136 519.247 297.972 518.775 297.972C518.303 297.972 517.927 298.136 517.647 298.464C517.367 298.792 517.227 299.292 517.227 299.964C517.227 300.636 517.367 301.14 517.647 301.476C517.927 301.804 518.303 301.968 518.775 301.968ZM523.128 303V298.488C523.128 298.232 523.12 297.972 523.104 297.708C523.096 297.444 523.076 297.188 523.044 296.94H524.496L524.664 298.596H524.424C524.504 298.196 524.636 297.864 524.82 297.6C525.012 297.336 525.244 297.14 525.516 297.012C525.788 296.884 526.084 296.82 526.404 296.82C526.548 296.82 526.664 296.828 526.752 296.844C526.84 296.852 526.928 296.872 527.016 296.904L527.004 298.224C526.852 298.16 526.72 298.12 526.608 298.104C526.504 298.088 526.372 298.08 526.212 298.08C525.868 298.08 525.576 298.152 525.336 298.296C525.104 298.44 524.928 298.64 524.808 298.896C524.696 299.152 524.64 299.444 524.64 299.772V303H523.128ZM530.109 303.12C529.581 303.12 529.113 302.996 528.705 302.748C528.305 302.492 527.993 302.128 527.769 301.656C527.545 301.184 527.433 300.62 527.433 299.964C527.433 299.308 527.545 298.748 527.769 298.284C527.993 297.812 528.305 297.452 528.705 297.204C529.113 296.948 529.581 296.82 530.109 296.82C530.613 296.82 531.057 296.944 531.441 297.192C531.833 297.432 532.093 297.76 532.221 298.176H532.065V294.168H533.565V303H532.089V301.716H532.233C532.105 302.148 531.845 302.492 531.453 302.748C531.069 302.996 530.621 303.12 530.109 303.12ZM530.529 301.968C531.001 301.968 531.381 301.804 531.669 301.476C531.957 301.14 532.101 300.636 532.101 299.964C532.101 299.292 531.957 298.792 531.669 298.464C531.381 298.136 531.001 297.972 530.529 297.972C530.057 297.972 529.673 298.136 529.377 298.464C529.089 298.792 528.945 299.292 528.945 299.964C528.945 300.636 529.089 301.14 529.377 301.476C529.673 301.804 530.057 301.968 530.529 301.968ZM538.127 303.12C537.111 303.12 536.315 302.84 535.739 302.28C535.163 301.72 534.875 300.952 534.875 299.976C534.875 299.344 534.999 298.792 535.247 298.32C535.495 297.848 535.839 297.48 536.279 297.216C536.727 296.952 537.247 296.82 537.839 296.82C538.423 296.82 538.911 296.944 539.303 297.192C539.695 297.44 539.991 297.788 540.191 298.236C540.399 298.684 540.503 299.208 540.503 299.808V300.204H536.087V299.412H539.435L539.231 299.58C539.231 299.02 539.111 298.592 538.871 298.296C538.639 298 538.299 297.852 537.851 297.852C537.355 297.852 536.971 298.028 536.699 298.38C536.435 298.732 536.303 299.224 536.303 299.856V300.012C536.303 300.668 536.463 301.16 536.783 301.488C537.111 301.808 537.571 301.968 538.163 301.968C538.507 301.968 538.827 301.924 539.123 301.836C539.427 301.74 539.715 301.588 539.987 301.38L540.431 302.388C540.143 302.62 539.799 302.8 539.399 302.928C538.999 303.056 538.575 303.12 538.127 303.12ZM541.761 303V298.488C541.761 298.232 541.753 297.972 541.737 297.708C541.729 297.444 541.709 297.188 541.677 296.94H543.129L543.297 298.596H543.057C543.137 298.196 543.269 297.864 543.453 297.6C543.645 297.336 543.877 297.14 544.149 297.012C544.421 296.884 544.717 296.82 545.037 296.82C545.181 296.82 545.297 296.828 545.385 296.844C545.473 296.852 545.561 296.872 545.649 296.904L545.637 298.224C545.485 298.16 545.353 298.12 545.241 298.104C545.137 298.088 545.005 298.08 544.845 298.08C544.501 298.08 544.209 298.152 543.969 298.296C543.737 298.44 543.561 298.64 543.441 298.896C543.329 299.152 543.273 299.444 543.273 299.772V303H541.761Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__tip_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Polygon 4_4",
  d: "M562 298L554 303L554 298L554 293L562 298Z",
  fill: "white"
})))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__label-extra",
  className: "label-extra",
  filter: "url(#prod_room_svg__filter4_d_6850_10576)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prod_room_svg__text_5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 427.994C16 426.889 16.8954 425.994 18 425.994H61C62.1046 425.994 63 426.889 63 427.994V447.994C63 449.099 62.1046 449.994 61 449.994H18C16.8954 449.994 16 449.099 16 447.994V427.994Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "prod_room_svg__Tooltip_5",
  d: "M25.2544 442.994V434.534H30.9544V435.746H26.7424V438.086H30.6784V439.31H26.7424V441.77H30.9544V442.994H25.2544ZM31.3351 442.994L34.1551 439.526V440.21L31.4911 436.934H33.2671L35.0071 439.178H34.4671L36.2071 436.934H37.9711L35.3311 440.21V439.526L38.1391 442.994H36.3511L34.4671 440.582H35.0071L33.1111 442.994H31.3351ZM41.449 443.114C40.729 443.114 40.185 442.926 39.817 442.55C39.449 442.174 39.265 441.61 39.265 440.858V438.062H38.101V436.934H39.265V435.386L40.765 435.002V436.934H42.385V438.062H40.765V440.762C40.765 441.178 40.845 441.47 41.005 441.638C41.165 441.806 41.385 441.89 41.665 441.89C41.817 441.89 41.945 441.878 42.049 441.854C42.161 441.83 42.269 441.798 42.373 441.758V442.946C42.237 443.002 42.085 443.042 41.917 443.066C41.757 443.098 41.601 443.114 41.449 443.114ZM43.3919 442.994V438.482C43.3919 438.226 43.3839 437.966 43.3679 437.702C43.3599 437.438 43.3399 437.182 43.3079 436.934H44.7599L44.9279 438.59H44.6879C44.7679 438.19 44.8999 437.858 45.0839 437.594C45.2759 437.33 45.5079 437.134 45.7799 437.006C46.0519 436.878 46.3479 436.814 46.6679 436.814C46.8119 436.814 46.9279 436.822 47.0159 436.838C47.1039 436.846 47.1919 436.866 47.2799 436.898L47.2679 438.218C47.1159 438.154 46.9839 438.114 46.8719 438.098C46.7679 438.082 46.6359 438.074 46.4759 438.074C46.1319 438.074 45.8399 438.146 45.5999 438.29C45.3679 438.434 45.1919 438.634 45.0719 438.89C44.9599 439.146 44.9039 439.438 44.9039 439.766V442.994H43.3919ZM50.3962 443.114C49.8682 443.114 49.4042 442.99 49.0042 442.742C48.6042 442.486 48.2922 442.122 48.0682 441.65C47.8442 441.178 47.7322 440.614 47.7322 439.958C47.7322 439.302 47.8442 438.742 48.0682 438.278C48.2922 437.806 48.6042 437.446 49.0042 437.198C49.4042 436.942 49.8682 436.814 50.3962 436.814C50.9082 436.814 51.3562 436.942 51.7402 437.198C52.1322 437.446 52.3922 437.782 52.5202 438.206H52.3882L52.5202 436.934H53.9602C53.9362 437.182 53.9122 437.434 53.8882 437.69C53.8722 437.946 53.8642 438.198 53.8642 438.446V442.994H52.3762L52.3642 441.746H52.5082C52.3802 442.162 52.1202 442.494 51.7282 442.742C51.3362 442.99 50.8922 443.114 50.3962 443.114ZM50.8162 441.962C51.2882 441.962 51.6682 441.798 51.9562 441.47C52.2442 441.134 52.3882 440.63 52.3882 439.958C52.3882 439.286 52.2442 438.786 51.9562 438.458C51.6682 438.13 51.2882 437.966 50.8162 437.966C50.3442 437.966 49.9642 438.13 49.6762 438.458C49.3882 438.786 49.2442 439.286 49.2442 439.958C49.2442 440.63 49.3842 441.134 49.6642 441.47C49.9522 441.798 50.3362 441.962 50.8162 441.962Z",
  fill: "#141941"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prod_room_svg__filter0_d_6850_10576",
  x: 238.431,
  y: 114.239,
  width: 208,
  height: 50,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6850_10576"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6850_10576",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "prod_room_svg__filter1_d_6850_10576",
  x: 232.434,
  y: 320.636,
  width: 152,
  height: 50,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6850_10576"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6850_10576",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "prod_room_svg__filter2_d_6850_10576",
  x: 274.357,
  y: 174.486,
  width: 175,
  height: 50,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6850_10576"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6850_10576",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "prod_room_svg__filter3_d_6850_10576",
  x: 439,
  y: 278,
  width: 133,
  height: 50,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6850_10576"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6850_10576",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "prod_room_svg__filter4_d_6850_10576",
  x: 6,
  y: 420.994,
  width: 67,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6850_10576"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6850_10576",
  result: "shape"
})))));
export default SvgProdRoom;